(function () {
  'use strict';

  // =============================================
  // CONSTANTS & CONFIG
  // =============================================

  // Root .loyalty-shop element — lang + API URL come from data-attributes set by Liquid
  var shopEl = document.querySelector('.loyalty-shop');
  var API_URL = (shopEl && shopEl.getAttribute('data-api-url')) ||
    'https://happyretention.letsmakefarmershappy.com';
  // Shopify App Proxy pad voor alle klant-specifieke storefront-calls. Root-relatief,
  // same-origin (happyfarmershop.com), GEEN market/locale-prefix — Shopify routeert
  // /apps/loyalty/* server-side door naar de app en voegt zelf de geverifieerde
  // logged_in_customer_id + signature toe. De client stuurt hier bewust GEEN
  // customer_id in mee (zie SECURITY-FIX blokkade B-1).
  var PROXY_BASE = '/apps/loyalty';
  var PAGE_LANG = (shopEl && shopEl.getAttribute('data-lang')) || 'nl';
  var CUSTOMER_NAME = (shopEl && shopEl.getAttribute('data-customer-name')) || '';
  // Multi-tenant discriminator voor de publieke /api/public/* endpoints (shop.permanent_domain,
  // bv. "happyfarmerna.myshopify.com"). Lege-string-fallback = backward-compatible: als het
  // attribuut ontbreekt (oude NL-live-situatie, thema nog niet bijgewerkt), voegt
  // withShopParam() geen query toe en blijft het gedrag exact zoals nu (server valt fail-open
  // terug op tenant 1).
  var SHOP_PARAM = (shopEl && shopEl.getAttribute('data-shop')) || '';

  // Voegt ?shop=/&shop= toe aan een URL op basis van SHOP_PARAM, met de juiste separator
  // afhankelijk van een reeds aanwezige querystring. Zonder SHOP_PARAM blijft de URL ongewijzigd.
  function withShopParam(url) {
    if (!SHOP_PARAM) return url;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'shop=' + encodeURIComponent(SHOP_PARAM);
  }

  // Promise die resolvet zodra applyContent() klaar is (of de safety-timeout slaat aan).
  // History- en my-rewards-renderers wachten hierop zodat data-t-* attributes al zijn
  // overschreven door de admin-config vóór de tabel wordt gebouwd.
  window._loyaltyConfigReady = new Promise(function (resolve) {
    window._loyaltyConfigResolve = resolve;
  });

  // Failsafe: na 3s alsnog tonen, ook als config niet kwam of JS faalt
  setTimeout(function () {
    var rootEl = document.querySelector('.loyalty-shop');
    if (rootEl && !rootEl.classList.contains('loyalty-shop--ready')) {
      rootEl.classList.add('loyalty-shop--ready');
    }
    if (window._loyaltyConfigResolve) { window._loyaltyConfigResolve(); window._loyaltyConfigResolve = null; }
  }, 3000);

  // Fallback values used when the config endpoint is unavailable.
  // Was FALLBACK_POINTS_PER_EUR — hernoemd naar een valuta-neutrale naam: de ratio
  // zelf is niet EUR-specifiek (geldt evengoed voor CAD op happyfarmerna.com), alleen
  // de LETTERLIJKE NAAM was dat nog. Het servercontract-veld `points_per_eur_discount`
  // (zie applyRedeemTiers hieronder) verandert bewust NIET mee — dat is een vast,
  // reeds live servercontract dat de huidige NL-theme ook leest.
  var FALLBACK_POINTS_PER_UNIT = 100;
  var FALLBACK_MIN_REDEEM = 500;
  var FALLBACK_REDEEM_TIERS = [500, 1000, 2000];

  // =============================================
  // TENANT-VALUTA/LOCALE STATE
  // =============================================
  // _configCurrency/_configContent/_configLang worden gevuld zodra
  // GET /api/public/loyalty-page-config succesvol antwoordt (zie applyConfig()).
  // Ze blijven op onderstaande defaults staan bij een totale config-storing — dat is
  // GEEN regressie t.o.v. vandaag: vóór deze fix toonde de pagina bij zo'n storing
  // ook altijd €, op BEIDE stores (happyfarmershop.com én happyfarmerna.com). Deze
  // fix verbetert het reguliere succespad (verreweg het grootste deel van het
  // verkeer, config heeft een 4s timeout + 5min CDN-cache); de zeldzame
  // total-outage-situatie blijft bewust op de oude EUR/NL-gok staan i.p.v. te raden.
  var _configCurrency = 'EUR';
  var _configContent = null;
  var _configLang = PAGE_LANG;
  // values.locale van de server — alleen gebruikt als PAGE_LANG zelf (de taal die
  // Liquid al per-request detecteert, incl. /fr en /en-us op happyfarmerna.com) niet
  // normaliseerbaar blijkt. Zie resolveLocale() hieronder voor de volledige keten.
  var _serverLocale = null;

  // =============================================
  // PER-LANGUAGE FALLBACK STRINGS
  // Matches the current hardcoded Liquid values exactly.
  // Used when config fetch fails — ensures the page
  // NEVER goes blank/broken on a live fetch error.
  // =============================================
  var FALLBACK_CONTENT = {
    nl: {
      hero: { welcome: 'Welkom terug, {name}!', points_label: 'punten' },
      redeem: {
        title: 'Punten inwisselen', subtitle: 'Wissel je punten in voor korting',
        balance_label: 'Je saldo:', quick_label: 'Snelkeuze:', custom_label: 'Of voer een eigen aantal in:',
        placeholder: 'bijv. 750', redeem_button: 'Inwisselen', pts_label: 'ptn',
        insufficient_points: 'Onvoldoende punten', min_points_needed: 'Minimaal {min} punten nodig',
        created_message: 'Kortingscode aangemaakt! Gebruik deze code bij je volgende bestelling:',
        value_label: 'Waarde:', valid_until_label: 'Geldig tot:', connection_error: 'Verbindingsfout:',
        copy_code: 'Kopieer code',
        login_required: 'Log in om punten in te wisselen',
        confirm_product: 'Wil je {points} punten inwisselen voor {title}?',
        processing: 'Bezig...', adding_to_cart: 'Toevoegen aan winkelwagen...',
        code_prefix: 'Code: ', add_to_cart_button: 'Voeg toe aan winkelwagen',
        redeemed: 'Ingewisseld!', your_code_prefix: 'Je code: ',
        add_to_cart_manual_button: 'Voeg zelf toe aan winkelwagen',
        error_not_logged_in: 'Niet ingelogd', error_request_expired: 'Verzoek verlopen',
        error_rate_limited: 'Te veel verzoeken. Probeer het later opnieuw.',
        error_customer_not_found: 'Klant niet gevonden',
        error_member_not_found: 'Klant niet gevonden in het loyaliteitsprogramma',
        error_invalid_points: 'Ongeldig aantal punten', error_points_required: 'Aantal punten is verplicht',
        error_product_id_required: 'Product is verplicht', error_referral_code_required: 'Referral-code is verplicht',
        error_values_required: 'Profielgegevens zijn verplicht',
        error_product_not_in_collection: 'Product niet gevonden in de beloningscollectie',
        error_product_no_points_price: 'Dit product heeft geen puntenprijs',
        error_profile_save_failed: 'Profiel kon niet worden opgeslagen. Probeer het later opnieuw.',
        error_field_expects_boolean: 'Veld \'{field}\' verwacht \'true\' of \'false\'',
        error_field_expects_number: 'Veld \'{field}\' verwacht een numerieke waarde',
        error_b2b_excluded: 'B2B-klanten zijn uitgesloten van het loyaliteitsprogramma',
        error_max_points_per_redeem: 'Maximaal {max} punten per keer inwisselen',
        insufficient_points_detail: 'Onvoldoende punten ({balance} van {needed} nodig)'
      },
      history: {
        title: 'Puntenhistorie', subtitle: 'Je laatste puntentransacties',
        col_date: 'Datum', col_desc: 'Omschrijving', col_points: 'Punten', col_balance: 'Saldo',
        empty: 'Nog geen transacties', type_earn: 'Verdiend', type_redeem: 'Ingewisseld',
        type_adjust: 'Correctie', type_expire: 'Verlopen'
      },
      rewards: { title: 'Beloningen', subtitle: 'Wissel punten in voor producten', redeem_button: 'Inwisselen', view_button: 'Bekijk', points_suffix: 'punten' },
      referral: {
        title: 'Beveel ons aan & verdien punten!',
        subtitle: 'Deel je persoonlijke code met collega-boeren. Zij krijgen korting op hun eerste bestelling — en jij verdient 200 bonuspunten!',
        step1_title: 'Deel je code', step1_desc: 'Via WhatsApp, telefoon of gewoon bij het hek — jij kiest',
        step2_title: 'Je collega bestelt', step2_desc: 'Met korting op de eerste bestelling',
        step3_title: 'Jij verdient 200 punten', step3_desc: 'Automatisch op je account bijgeschreven',
        code_label: 'Jouw persoonlijke code', link_label: 'Of deel deze directe link',
        copy_code: 'Kopieer code', copy_link: 'Kopieer link',
        whatsapp: 'Deel via WhatsApp', copied: 'Gekopieerd!',
        points_earned_suffix: 'punten verdiend'
      },
      profile: {
        title: 'Profiel compleet maken', subtitle: 'Verdien bonuspunten door je profiel in te vullen',
        save: 'Opslaan', saved: 'Profiel opgeslagen!', earned: 'punten verdiend',
        earn: 'punten', progress: 'Profiel', select: 'Selecteer...',
        other_placeholder: 'Anders, namelijk...'
      },
      tiers: {
        title: 'Loyaliteitsniveaus', from: 'Vanaf', points_per: 'punten per',
        discount: 'korting', shipping: 'Gratis verzending', current: 'Jouw niveau',
        bronze: 'Brons', silver: 'Zilver', gold: 'Goud', platinum: 'Platina'
      },
      guest: {
        title: 'Word lid van ons loyaliteitsprogramma',
        subtitle: 'Verdien punten bij elke bestelling en geniet van exclusieve voordelen.',
        login: 'Inloggen', how_it_works: 'Hoe het werkt',
        step1_title: 'Bestel & verdien', step1_desc: 'Verdien punten bij elke aankoop',
        step2_title: 'Stijg in niveau', step2_desc: 'Hogere niveaus, meer voordelen',
        step3_title: 'Wissel in', step3_desc: 'Gebruik punten voor kortingen & beloningen',
        start_shopping: 'Plaats je eerste bestelling om punten te sparen'
      }
    },
    de: {
      hero: { welcome: 'Willkommen zurück, {name}!', points_label: 'Punkte' },
      redeem: {
        title: 'Punkte einlösen', subtitle: 'Löse deine Punkte gegen Rabatt ein',
        balance_label: 'Dein Guthaben:', quick_label: 'Schnellauswahl:', custom_label: 'Oder gib eine eigene Anzahl ein:',
        placeholder: 'z.B. 750', redeem_button: 'Einlösen', pts_label: 'Pkt',
        insufficient_points: 'Nicht genügend Punkte', min_points_needed: 'Mindestens {min} Punkte erforderlich',
        created_message: 'Rabattcode erstellt! Verwende diesen Code bei deiner nächsten Bestellung:',
        value_label: 'Wert:', valid_until_label: 'Gültig bis:', connection_error: 'Verbindungsfehler:',
        copy_code: 'Code kopieren',
        login_required: 'Melde dich an, um Punkte einzulösen',
        confirm_product: 'Möchtest du {points} Punkte gegen {title} einlösen?',
        processing: 'Wird bearbeitet...', adding_to_cart: 'Wird zum Warenkorb hinzugefügt...',
        code_prefix: 'Code: ', add_to_cart_button: 'Zum Warenkorb hinzufügen',
        redeemed: 'Eingelöst!', your_code_prefix: 'Dein Code: ',
        add_to_cart_manual_button: 'Selbst zum Warenkorb hinzufügen',
        error_not_logged_in: 'Nicht angemeldet', error_request_expired: 'Anfrage abgelaufen',
        error_rate_limited: 'Zu viele Anfragen. Bitte versuche es später erneut.',
        error_customer_not_found: 'Kunde nicht gefunden',
        error_member_not_found: 'Kunde nicht im Treueprogramm gefunden',
        error_invalid_points: 'Ungültige Punktzahl', error_points_required: 'Punktzahl ist erforderlich',
        error_product_id_required: 'Produkt ist erforderlich', error_referral_code_required: 'Empfehlungscode ist erforderlich',
        error_values_required: 'Profildaten sind erforderlich',
        error_product_not_in_collection: 'Produkt nicht in der Prämien-Kollektion gefunden',
        error_product_no_points_price: 'Dieses Produkt hat keinen Punktepreis',
        error_profile_save_failed: 'Profil konnte nicht gespeichert werden. Bitte versuche es später erneut.',
        error_field_expects_boolean: 'Feld \'{field}\' erwartet \'true\' oder \'false\'',
        error_field_expects_number: 'Feld \'{field}\' erwartet einen numerischen Wert',
        error_b2b_excluded: 'B2B-Kunden sind vom Treueprogramm ausgeschlossen',
        error_max_points_per_redeem: 'Maximal {max} Punkte pro Einlösung',
        insufficient_points_detail: 'Nicht genügend Punkte ({balance} von {needed} benötigt)'
      },
      history: {
        title: 'Punkteübersicht', subtitle: 'Deine letzten Punktetransaktionen',
        col_date: 'Datum', col_desc: 'Beschreibung', col_points: 'Punkte', col_balance: 'Saldo',
        empty: 'Noch keine Transaktionen', type_earn: 'Verdient', type_redeem: 'Eingelöst',
        type_adjust: 'Korrektur', type_expire: 'Verfallen'
      },
      rewards: { title: 'Belohnungen', subtitle: 'Punkte gegen Produkte einlösen', redeem_button: 'Einlösen', view_button: 'Ansehen', points_suffix: 'Punkte' },
      referral: {
        title: 'Empfehle uns weiter & verdiene Punkte!',
        subtitle: 'Teile deinen persönlichen Code mit Kollegen. Sie erhalten Rabatt auf ihre erste Bestellung — und du verdienst 200 Bonuspunkte!',
        step1_title: 'Teile deinen Code', step1_desc: 'Per WhatsApp, Anruf oder persönlich — wie du möchtest',
        step2_title: 'Dein Kollege bestellt', step2_desc: 'Mit Rabatt auf die erste Bestellung',
        step3_title: 'Du verdienst 200 Punkte', step3_desc: 'Automatisch auf deinem Konto gutgeschrieben',
        code_label: 'Dein persönlicher Empfehlungscode', link_label: 'Oder teile diesen Direktlink',
        copy_code: 'Code kopieren', copy_link: 'Link kopieren',
        whatsapp: 'Per WhatsApp teilen', copied: 'Kopiert!',
        points_earned_suffix: 'Punkte verdient'
      },
      profile: {
        title: 'Profil vervollständigen', subtitle: 'Verdiene Bonuspunkte, indem du dein Profil ausfüllst',
        save: 'Speichern', saved: 'Profil gespeichert!', earned: 'Punkte verdient',
        earn: 'Punkte', progress: 'Profil', select: 'Wählen...',
        other_placeholder: 'Sonstiges, und zwar...'
      },
      tiers: {
        title: 'Treuestufen', from: 'Ab', points_per: 'Punkte pro',
        discount: 'Rabatt', shipping: 'Kostenloser Versand', current: 'Dein Level',
        bronze: 'Bronze', silver: 'Silber', gold: 'Gold', platinum: 'Platin'
      },
      guest: {
        title: 'Mitglied werden', subtitle: 'Sammle Punkte bei jeder Bestellung.',
        login: 'Anmelden', how_it_works: 'So funktioniert es',
        step1_title: 'Bestellen & sammeln', step1_desc: 'Punkte bei jedem Kauf verdienen',
        step2_title: 'Aufsteigen', step2_desc: 'Höhere Stufen, mehr Vorteile',
        step3_title: 'Einlösen', step3_desc: 'Punkte gegen Rabatte & Prämien tauschen',
        start_shopping: 'Gib deine erste Bestellung auf und sammle Punkte'
      }
    },
    fr: {
      hero: { welcome: 'Bienvenue, {name}!', points_label: 'points' },
      redeem: {
        title: 'Échanger des points', subtitle: 'Échangez vos points contre une réduction',
        balance_label: 'Votre solde:', quick_label: 'Sélection rapide:', custom_label: 'Ou entrez un nombre personnalisé:',
        placeholder: 'ex. 750', redeem_button: 'Échanger', pts_label: 'pts',
        insufficient_points: 'Points insuffisants', min_points_needed: 'Minimum {min} points requis',
        created_message: 'Code de réduction créé ! Utilisez ce code lors de votre prochaine commande :',
        value_label: 'Valeur :', valid_until_label: 'Valable jusqu\'au :', connection_error: 'Erreur de connexion :',
        copy_code: 'Copier le code',
        login_required: 'Connectez-vous pour échanger des points',
        confirm_product: 'Voulez-vous échanger {points} points contre {title} ?',
        processing: 'Traitement...', adding_to_cart: 'Ajout au panier...',
        code_prefix: 'Code : ', add_to_cart_button: 'Ajouter au panier',
        redeemed: 'Échangé !', your_code_prefix: 'Votre code : ',
        add_to_cart_manual_button: 'Ajoutez-le vous-même au panier',
        error_not_logged_in: 'Non connecté', error_request_expired: 'Requête expirée',
        error_rate_limited: 'Trop de requêtes. Réessayez plus tard.',
        error_customer_not_found: 'Client introuvable',
        error_member_not_found: 'Client introuvable dans le programme de fidélité',
        error_invalid_points: 'Nombre de points invalide', error_points_required: 'Le nombre de points est requis',
        error_product_id_required: 'Le produit est requis', error_referral_code_required: 'Le code de parrainage est requis',
        error_values_required: 'Les informations du profil sont requises',
        error_product_not_in_collection: 'Produit introuvable dans la collection de récompenses',
        error_product_no_points_price: 'Ce produit n\'a pas de prix en points',
        error_profile_save_failed: 'Le profil n\'a pas pu être enregistré. Réessayez plus tard.',
        error_field_expects_boolean: 'Le champ \'{field}\' attend \'true\' ou \'false\'',
        error_field_expects_number: 'Le champ \'{field}\' attend une valeur numérique',
        error_b2b_excluded: 'Les clients B2B sont exclus du programme de fidélité',
        error_max_points_per_redeem: 'Maximum {max} points par échange',
        insufficient_points_detail: 'Points insuffisants ({balance} sur {needed} nécessaires)'
      },
      history: {
        title: 'Historique des points', subtitle: 'Vos dernières transactions de points',
        col_date: 'Date', col_desc: 'Description', col_points: 'Points', col_balance: 'Solde',
        empty: 'Aucune transaction', type_earn: 'Gagné', type_redeem: 'Utilisé',
        type_adjust: 'Correction', type_expire: 'Expiré'
      },
      rewards: { title: 'Récompenses', subtitle: 'Échangez des points contre des produits', redeem_button: 'Échanger', view_button: 'Voir', points_suffix: 'points' },
      referral: {
        title: 'Parrainez un collègue & gagnez des points!',
        subtitle: 'Partagez votre code avec vos collègues. Ils obtiennent une réduction sur leur première commande — et vous gagnez 200 points bonus!',
        step1_title: 'Partagez votre code', step1_desc: 'Par WhatsApp, téléphone ou en personne',
        step2_title: 'Votre collègue commande', step2_desc: 'Avec une réduction sur sa première commande',
        step3_title: 'Vous gagnez 200 points', step3_desc: 'Automatiquement crédités sur votre compte',
        code_label: 'Votre code personnel', link_label: 'Ou partagez ce lien direct',
        copy_code: 'Copier le code', copy_link: 'Copier le lien',
        whatsapp: 'Partager par WhatsApp', copied: 'Copié!',
        points_earned_suffix: 'points gagnés'
      },
      profile: {
        title: 'Compléter votre profil', subtitle: 'Gagnez des points bonus en remplissant votre profil',
        save: 'Enregistrer', saved: 'Profil enregistré!', earned: 'points gagnés',
        earn: 'points', progress: 'Profil', select: 'Choisir...',
        other_placeholder: 'Autre, précisez...'
      },
      tiers: {
        title: 'Niveaux de fidélité', from: 'Dès', points_per: 'points par',
        discount: 'réduction', shipping: 'Livraison gratuite', current: 'Votre niveau',
        bronze: 'Bronze', silver: 'Argent', gold: 'Or', platinum: 'Platine'
      },
      guest: {
        title: 'Rejoignez notre programme', subtitle: 'Gagnez des points à chaque commande.',
        login: 'Se connecter', how_it_works: 'Comment ça marche',
        step1_title: 'Commandez & gagnez', step1_desc: 'Points à chaque achat',
        step2_title: 'Progressez', step2_desc: 'Niveaux supérieurs, plus d\'avantages',
        step3_title: 'Échangez', step3_desc: 'Utilisez les points pour des réductions',
        start_shopping: 'Passez votre première commande pour gagner des points'
      }
    },
    en: {
      hero: { welcome: 'Welcome back, {name}!', points_label: 'points' },
      redeem: {
        title: 'Redeem points', subtitle: 'Exchange your points for a discount',
        balance_label: 'Your balance:', quick_label: 'Quick select:', custom_label: 'Or enter a custom amount:',
        placeholder: 'e.g. 750', redeem_button: 'Redeem', pts_label: 'pts',
        insufficient_points: 'Insufficient points', min_points_needed: 'Minimum of {min} points required',
        created_message: 'Discount code created! Use this code on your next order:',
        value_label: 'Value:', valid_until_label: 'Valid until:', connection_error: 'Connection error:',
        copy_code: 'Copy code',
        login_required: 'Log in to redeem points',
        confirm_product: 'Do you want to redeem {points} points for {title}?',
        processing: 'Processing...', adding_to_cart: 'Adding to cart...',
        code_prefix: 'Code: ', add_to_cart_button: 'Add to cart',
        redeemed: 'Redeemed!', your_code_prefix: 'Your code: ',
        add_to_cart_manual_button: 'Add to cart yourself',
        error_not_logged_in: 'Not logged in', error_request_expired: 'Request expired',
        error_rate_limited: 'Too many requests. Please try again later.',
        error_customer_not_found: 'Customer not found',
        error_member_not_found: 'Customer not found in the loyalty programme',
        error_invalid_points: 'Invalid number of points', error_points_required: 'Number of points is required',
        error_product_id_required: 'Product is required', error_referral_code_required: 'Referral code is required',
        error_values_required: 'Profile details are required',
        error_product_not_in_collection: 'Product not found in the rewards collection',
        error_product_no_points_price: 'This product has no points price',
        error_profile_save_failed: 'Profile could not be saved. Please try again later.',
        error_field_expects_boolean: 'Field \'{field}\' expects \'true\' or \'false\'',
        error_field_expects_number: 'Field \'{field}\' expects a numeric value',
        error_b2b_excluded: 'B2B customers are excluded from the loyalty programme',
        error_max_points_per_redeem: 'Maximum {max} points per redemption',
        insufficient_points_detail: 'Insufficient points ({balance} of {needed} needed)'
      },
      history: {
        title: 'Points history', subtitle: 'Your recent point transactions',
        col_date: 'Date', col_desc: 'Description', col_points: 'Points', col_balance: 'Balance',
        empty: 'No transactions yet', type_earn: 'Earned', type_redeem: 'Redeemed',
        type_adjust: 'Adjustment', type_expire: 'Expired'
      },
      rewards: { title: 'Rewards', subtitle: 'Redeem points for products', redeem_button: 'Redeem', view_button: 'View', points_suffix: 'points' },
      referral: {
        title: 'Recommend us & earn points!',
        subtitle: 'Share your personal code with fellow farmers. They get a discount on their first order — and you earn 200 bonus points!',
        step1_title: 'Share your code', step1_desc: 'Via WhatsApp, phone or in person — your choice',
        step2_title: 'Your friend orders', step2_desc: 'With a discount on their first order',
        step3_title: 'You earn 200 points', step3_desc: 'Automatically added to your account',
        code_label: 'Your personal referral code', link_label: 'Or share this direct link',
        copy_code: 'Copy code', copy_link: 'Copy link',
        whatsapp: 'Share via WhatsApp', copied: 'Copied!',
        points_earned_suffix: 'points earned'
      },
      profile: {
        title: 'Complete your profile', subtitle: 'Earn bonus points by filling in your profile',
        save: 'Save', saved: 'Profile saved!', earned: 'points earned',
        earn: 'points', progress: 'Profile', select: 'Select...',
        other_placeholder: 'Other, please specify...'
      },
      tiers: {
        title: 'Loyalty tiers', from: 'From', points_per: 'points per',
        discount: 'discount', shipping: 'Free shipping', current: 'Your tier',
        bronze: 'Bronze', silver: 'Silver', gold: 'Gold', platinum: 'Platinum'
      },
      guest: {
        title: 'Join our loyalty programme', subtitle: 'Earn points on every order.',
        login: 'Log in', how_it_works: 'How it works',
        step1_title: 'Order & earn', step1_desc: 'Earn points on every purchase',
        step2_title: 'Level up', step2_desc: 'Higher tiers, more benefits',
        step3_title: 'Redeem', step3_desc: 'Use points for discounts & rewards',
        start_shopping: 'Place your first order to start earning points'
      }
    },
    da: {
      hero: { welcome: 'Velkommen tilbage, {name}!', points_label: 'point' },
      redeem: {
        title: 'Indløs point', subtitle: 'Brug dine point til rabat',
        balance_label: 'Din saldo:', quick_label: 'Hurtigvalg:', custom_label: 'Eller indtast et eget antal:',
        placeholder: 'fx 750', redeem_button: 'Indløs', pts_label: 'ptn',
        insufficient_points: 'Ikke nok point', min_points_needed: 'Minimum {min} point påkrævet',
        created_message: 'Rabatkode oprettet! Brug denne kode ved din næste bestilling:',
        value_label: 'Værdi:', valid_until_label: 'Gyldig til:', connection_error: 'Forbindelsesfejl:',
        copy_code: 'Kopier kode',
        login_required: 'Log ind for at indløse point',
        confirm_product: 'Vil du indløse {points} point til {title}?',
        processing: 'Behandler...', adding_to_cart: 'Tilføjer til kurv...',
        code_prefix: 'Kode: ', add_to_cart_button: 'Læg i kurv',
        redeemed: 'Indløst!', your_code_prefix: 'Din kode: ',
        add_to_cart_manual_button: 'Læg selv i kurv',
        error_not_logged_in: 'Ikke logget ind', error_request_expired: 'Anmodning udløbet',
        error_rate_limited: 'For mange anmodninger. Prøv igen senere.',
        error_customer_not_found: 'Kunde ikke fundet',
        error_member_not_found: 'Kunde ikke fundet i loyalitetsprogrammet',
        error_invalid_points: 'Ugyldigt antal point', error_points_required: 'Antal point er påkrævet',
        error_product_id_required: 'Produkt er påkrævet', error_referral_code_required: 'Henvisningskode er påkrævet',
        error_values_required: 'Profiloplysninger er påkrævet',
        error_product_not_in_collection: 'Produkt ikke fundet i belønningskollektionen',
        error_product_no_points_price: 'Dette produkt har ingen pointpris',
        error_profile_save_failed: 'Profilen kunne ikke gemmes. Prøv igen senere.',
        error_field_expects_boolean: 'Feltet \'{field}\' forventer \'true\' eller \'false\'',
        error_field_expects_number: 'Feltet \'{field}\' forventer en numerisk værdi',
        error_b2b_excluded: 'B2B-kunder er udelukket fra loyalitetsprogrammet',
        error_max_points_per_redeem: 'Maksimalt {max} point pr. indløsning',
        insufficient_points_detail: 'Ikke nok point ({balance} af {needed} påkrævet)'
      },
      history: {
        title: 'Pointhistorik', subtitle: 'Dine seneste pointtransaktioner',
        col_date: 'Dato', col_desc: 'Beskrivelse', col_points: 'Point', col_balance: 'Saldo',
        empty: 'Ingen transaktioner endnu', type_earn: 'Optjent', type_redeem: 'Indløst',
        type_adjust: 'Justering', type_expire: 'Udløbet'
      },
      rewards: { title: 'Belønninger', subtitle: 'Brug point på produkter', redeem_button: 'Indløs', view_button: 'Se', points_suffix: 'point' },
      referral: {
        title: 'Anbefal os & optjen point!',
        subtitle: 'Del din personlige kode med kolleger. De får rabat på deres første ordre — og du optjener 200 bonuspoint!',
        step1_title: 'Del din kode', step1_desc: 'Via WhatsApp, telefon eller personligt',
        step2_title: 'Din kollega bestiller', step2_desc: 'Med rabat på første ordre',
        step3_title: 'Du optjener 200 point', step3_desc: 'Automatisk krediteret på din konto',
        code_label: 'Din personlige kode', link_label: 'Eller del dette direkte link',
        copy_code: 'Kopier kode', copy_link: 'Kopier link',
        whatsapp: 'Del via WhatsApp', copied: 'Kopieret!',
        points_earned_suffix: 'point optjent'
      },
      profile: {
        title: 'Udfyld din profil', subtitle: 'Tjen bonuspoint ved at udfylde din profil',
        save: 'Gem', saved: 'Profil gemt!', earned: 'point optjent',
        earn: 'point', progress: 'Profil', select: 'Vælg...',
        other_placeholder: 'Andet, angiv venligst...'
      },
      tiers: {
        title: 'Loyalitetsniveauer', from: 'Fra', points_per: 'point pr.',
        discount: 'rabat', shipping: 'Gratis fragt', current: 'Dit niveau',
        bronze: 'Bronze', silver: 'Sølv', gold: 'Guld', platinum: 'Platin'
      },
      guest: {
        title: 'Bliv medlem', subtitle: 'Optjen point ved hver ordre.',
        login: 'Log ind', how_it_works: 'Sådan fungerer det',
        step1_title: 'Bestil & optjen', step1_desc: 'Point ved hvert køb',
        step2_title: 'Steg i niveau', step2_desc: 'Højere niveau, flere fordele',
        step3_title: 'Indløs', step3_desc: 'Brug point til rabatter',
        start_shopping: 'Afgiv din første ordre for at begynde at optjene point'
      }
    },
    sv: {
      hero: { welcome: 'Välkommen tillbaka, {name}!', points_label: 'poäng' },
      redeem: {
        title: 'Lös in poäng', subtitle: 'Byt dina poäng mot rabatt',
        balance_label: 'Ditt saldo:', quick_label: 'Snabbval:', custom_label: 'Eller ange ett eget antal:',
        placeholder: 'ex. 750', redeem_button: 'Lös in', pts_label: 'ptn',
        insufficient_points: 'Otillräckligt med poäng', min_points_needed: 'Minst {min} poäng krävs',
        created_message: 'Rabattkod skapad! Använd denna kod vid din nästa beställning:',
        value_label: 'Värde:', valid_until_label: 'Giltig till:', connection_error: 'Anslutningsfel:',
        copy_code: 'Kopiera kod',
        login_required: 'Logga in för att lösa in poäng',
        confirm_product: 'Vill du lösa in {points} poäng mot {title}?',
        processing: 'Bearbetar...', adding_to_cart: 'Lägger till i varukorgen...',
        code_prefix: 'Kod: ', add_to_cart_button: 'Lägg i varukorgen',
        redeemed: 'Inlöst!', your_code_prefix: 'Din kod: ',
        add_to_cart_manual_button: 'Lägg själv i varukorgen',
        error_not_logged_in: 'Inte inloggad', error_request_expired: 'Begäran har gått ut',
        error_rate_limited: 'För många förfrågningar. Försök igen senare.',
        error_customer_not_found: 'Kunden hittades inte',
        error_member_not_found: 'Kunden hittades inte i lojalitetsprogrammet',
        error_invalid_points: 'Ogiltigt antal poäng', error_points_required: 'Antal poäng krävs',
        error_product_id_required: 'Produkt krävs', error_referral_code_required: 'Rekommendationskod krävs',
        error_values_required: 'Profiluppgifter krävs',
        error_product_not_in_collection: 'Produkten hittades inte i belöningskollektionen',
        error_product_no_points_price: 'Denna produkt har inget poängpris',
        error_profile_save_failed: 'Profilen kunde inte sparas. Försök igen senare.',
        error_field_expects_boolean: 'Fältet \'{field}\' förväntar \'true\' eller \'false\'',
        error_field_expects_number: 'Fältet \'{field}\' förväntar ett numeriskt värde',
        error_b2b_excluded: 'B2B-kunder är uteslutna från lojalitetsprogrammet',
        error_max_points_per_redeem: 'Max {max} poäng per inlösen',
        insufficient_points_detail: 'Otillräckligt med poäng ({balance} av {needed} krävs)'
      },
      history: {
        title: 'Poänghistorik', subtitle: 'Dina senaste poängtransaktioner',
        col_date: 'Datum', col_desc: 'Beskrivning', col_points: 'Poäng', col_balance: 'Saldo',
        empty: 'Inga transaktioner ännu', type_earn: 'Intjänat', type_redeem: 'Inlöst',
        type_adjust: 'Justering', type_expire: 'Utgånget'
      },
      rewards: { title: 'Belöningar', subtitle: 'Lös in poäng mot produkter', redeem_button: 'Lös in', view_button: 'Visa', points_suffix: 'poäng' },
      referral: {
        title: 'Rekommendera oss & tjäna poäng!',
        subtitle: 'Dela din personliga kod med kollegor. De får rabatt på sin första beställning — och du tjänar 200 bonuspoäng!',
        step1_title: 'Dela din kod', step1_desc: 'Via WhatsApp, telefon eller personligen',
        step2_title: 'Din kollega beställer', step2_desc: 'Med rabatt på första ordern',
        step3_title: 'Du tjänar 200 poäng', step3_desc: 'Automatiskt krediterat på ditt konto',
        code_label: 'Din personliga kod', link_label: 'Eller dela denna direktlänk',
        copy_code: 'Kopiera kod', copy_link: 'Kopiera länk',
        whatsapp: 'Dela via WhatsApp', copied: 'Kopierat!',
        points_earned_suffix: 'poäng intjänade'
      },
      profile: {
        title: 'Fyll i din profil', subtitle: 'Tjäna bonuspoäng genom att fylla i din profil',
        save: 'Spara', saved: 'Profil sparad!', earned: 'poäng intjänade',
        earn: 'poäng', progress: 'Profil', select: 'Välj...',
        other_placeholder: 'Annat, ange...'
      },
      tiers: {
        title: 'Lojalitetsnivåer', from: 'Från', points_per: 'poäng per',
        discount: 'rabatt', shipping: 'Fri frakt', current: 'Din nivå',
        bronze: 'Brons', silver: 'Silver', gold: 'Guld', platinum: 'Platina'
      },
      guest: {
        title: 'Gå med i lojalitetsprogrammet', subtitle: 'Tjäna poäng vid varje beställning.',
        login: 'Logga in', how_it_works: 'Så här fungerar det',
        step1_title: 'Beställ & tjäna', step1_desc: 'Poäng vid varje köp',
        step2_title: 'Steg upp', step2_desc: 'Högre nivåer, fler fördelar',
        step3_title: 'Lös in', step3_desc: 'Använd poäng för rabatter',
        start_shopping: 'Lägg din första beställning för att börja tjäna poäng'
      }
    },
    no: {
      hero: { welcome: 'Velkommen tilbake, {name}!', points_label: 'poeng' },
      redeem: {
        title: 'Løs inn poeng', subtitle: 'Bruk poengene dine til rabatt',
        balance_label: 'Din saldo:', quick_label: 'Hurtigvalg:', custom_label: 'Eller oppgi et eget antall:',
        placeholder: 'f.eks. 750', redeem_button: 'Løs inn', pts_label: 'ptn',
        insufficient_points: 'Ikke nok poeng', min_points_needed: 'Minimum {min} poeng kreves',
        created_message: 'Rabattkode opprettet! Bruk denne koden på din neste bestilling:',
        value_label: 'Verdi:', valid_until_label: 'Gyldig til:', connection_error: 'Tilkoblingsfeil:',
        copy_code: 'Kopier kode',
        login_required: 'Logg inn for å løse inn poeng',
        confirm_product: 'Vil du løse inn {points} poeng mot {title}?',
        processing: 'Behandler...', adding_to_cart: 'Legger til i handlekurven...',
        code_prefix: 'Kode: ', add_to_cart_button: 'Legg i handlekurv',
        redeemed: 'Løst inn!', your_code_prefix: 'Din kode: ',
        add_to_cart_manual_button: 'Legg selv i handlekurven',
        error_not_logged_in: 'Ikke logget inn', error_request_expired: 'Forespørsel utløpt',
        error_rate_limited: 'For mange forespørsler. Prøv igjen senere.',
        error_customer_not_found: 'Kunde ikke funnet',
        error_member_not_found: 'Kunde ikke funnet i lojalitetsprogrammet',
        error_invalid_points: 'Ugyldig antall poeng', error_points_required: 'Antall poeng er påkrevd',
        error_product_id_required: 'Produkt er påkrevd', error_referral_code_required: 'Anbefalingskode er påkrevd',
        error_values_required: 'Profilopplysninger er påkrevd',
        error_product_not_in_collection: 'Produkt ikke funnet i belønningskolleksjonen',
        error_product_no_points_price: 'Dette produktet har ingen poengpris',
        error_profile_save_failed: 'Profilen kunne ikke lagres. Prøv igjen senere.',
        error_field_expects_boolean: 'Feltet \'{field}\' forventer \'true\' eller \'false\'',
        error_field_expects_number: 'Feltet \'{field}\' forventer en numerisk verdi',
        error_b2b_excluded: 'B2B-kunder er ekskludert fra lojalitetsprogrammet',
        error_max_points_per_redeem: 'Maks {max} poeng per innløsning',
        insufficient_points_detail: 'Ikke nok poeng ({balance} av {needed} kreves)'
      },
      history: {
        title: 'Poenghistorikk', subtitle: 'Dine siste poengtransaksjoner',
        col_date: 'Dato', col_desc: 'Beskrivelse', col_points: 'Poeng', col_balance: 'Saldo',
        empty: 'Ingen transaksjoner ennå', type_earn: 'Opptjent', type_redeem: 'Innløst',
        type_adjust: 'Justering', type_expire: 'Utløpt'
      },
      rewards: { title: 'Belønninger', subtitle: 'Bruk poeng på produkter', redeem_button: 'Løs inn', view_button: 'Se', points_suffix: 'poeng' },
      referral: {
        title: 'Anbefal oss & tjen poeng!',
        subtitle: 'Del din personlige kode med kolleger. De får rabatt på sin første bestilling — og du tjener 200 bonuspoeng!',
        step1_title: 'Del koden din', step1_desc: 'Via WhatsApp, telefon eller personlig',
        step2_title: 'Kollegaen din bestiller', step2_desc: 'Med rabatt på første bestilling',
        step3_title: 'Du tjener 200 poeng', step3_desc: 'Automatisk kreditert på kontoen din',
        code_label: 'Din personlige kode', link_label: 'Eller del denne direktelenken',
        copy_code: 'Kopier kode', copy_link: 'Kopier lenke',
        whatsapp: 'Del via WhatsApp', copied: 'Kopiert!',
        points_earned_suffix: 'poeng opptjent'
      },
      profile: {
        title: 'Fyll ut profilen din', subtitle: 'Tjen bonuspoeng ved å fylle ut profilen din',
        save: 'Lagre', saved: 'Profil lagret!', earned: 'poeng opptjent',
        earn: 'poeng', progress: 'Profil', select: 'Velg...',
        other_placeholder: 'Annet, angi...'
      },
      tiers: {
        title: 'Lojalitetsnivåer', from: 'Fra', points_per: 'poeng per',
        discount: 'rabatt', shipping: 'Gratis frakt', current: 'Ditt nivå',
        bronze: 'Bronse', silver: 'Sølv', gold: 'Gull', platinum: 'Platina'
      },
      guest: {
        title: 'Bli medlem', subtitle: 'Tjen poeng ved hver bestilling.',
        login: 'Logg inn', how_it_works: 'Slik fungerer det',
        step1_title: 'Bestill & tjen', step1_desc: 'Poeng ved hvert kjøp',
        step2_title: 'Klatre i nivå', step2_desc: 'Høyere nivå, flere fordeler',
        step3_title: 'Løs inn', step3_desc: 'Bruk poeng til rabatter',
        start_shopping: 'Legg inn din første bestilling for å begynne å tjene poeng'
      }
    },
    fi: {
      hero: { welcome: 'Tervetuloa takaisin, {name}!', points_label: 'pistettä' },
      redeem: {
        title: 'Lunasta pisteet', subtitle: 'Vaihda pisteesi alennukseksi',
        balance_label: 'Saldosi:', quick_label: 'Pikavalikko:', custom_label: 'Tai syötä oma määrä:',
        placeholder: 'esim. 750', redeem_button: 'Lunasta', pts_label: 'pst',
        insufficient_points: 'Ei tarpeeksi pisteitä', min_points_needed: 'Vähintään {min} pistettä vaaditaan',
        created_message: 'Alennuskoodi luotu! Käytä tätä koodia seuraavassa tilauksessasi:',
        value_label: 'Arvo:', valid_until_label: 'Voimassa asti:', connection_error: 'Yhteysvirhe:',
        copy_code: 'Kopioi koodi',
        login_required: 'Kirjaudu sisään lunastaaksesi pisteitä',
        confirm_product: 'Haluatko lunastaa {points} pistettä tuotteesta {title}?',
        processing: 'Käsitellään...', adding_to_cart: 'Lisätään ostoskoriin...',
        code_prefix: 'Koodi: ', add_to_cart_button: 'Lisää ostoskoriin',
        redeemed: 'Lunastettu!', your_code_prefix: 'Koodisi: ',
        add_to_cart_manual_button: 'Lisää itse ostoskoriin',
        error_not_logged_in: 'Et ole kirjautunut sisään', error_request_expired: 'Pyyntö on vanhentunut',
        error_rate_limited: 'Liian monta pyyntöä. Yritä myöhemmin uudelleen.',
        error_customer_not_found: 'Asiakasta ei löytynyt',
        error_member_not_found: 'Asiakasta ei löytynyt kanta-asiakasohjelmasta',
        error_invalid_points: 'Virheellinen pistemäärä', error_points_required: 'Pistemäärä vaaditaan',
        error_product_id_required: 'Tuote vaaditaan', error_referral_code_required: 'Suosittelukoodi vaaditaan',
        error_values_required: 'Profiilitiedot vaaditaan',
        error_product_not_in_collection: 'Tuotetta ei löytynyt palkintovalikoimasta',
        error_product_no_points_price: 'Tällä tuotteella ei ole pistehintaa',
        error_profile_save_failed: 'Profiilia ei voitu tallentaa. Yritä myöhemmin uudelleen.',
        error_field_expects_boolean: 'Kenttä \'{field}\' odottaa arvoa \'true\' tai \'false\'',
        error_field_expects_number: 'Kenttä \'{field}\' odottaa numeerista arvoa',
        error_b2b_excluded: 'B2B-asiakkaat on suljettu kanta-asiakasohjelman ulkopuolelle',
        error_max_points_per_redeem: 'Enintään {max} pistettä per lunastus',
        insufficient_points_detail: 'Ei tarpeeksi pisteitä ({balance}/{needed} tarvitaan)'
      },
      history: {
        title: 'Pistehistoria', subtitle: 'Viimeisimmät pistetapahtumat',
        col_date: 'Päivämäärä', col_desc: 'Kuvaus', col_points: 'Pisteet', col_balance: 'Saldo',
        empty: 'Ei vielä tapahtumia', type_earn: 'Ansaittu', type_redeem: 'Lunastettu',
        type_adjust: 'Oikaisu', type_expire: 'Vanhentunut'
      },
      rewards: { title: 'Palkinnot', subtitle: 'Lunasta pisteitä tuotteiksi', redeem_button: 'Lunasta', view_button: 'Katso', points_suffix: 'pistettä' },
      referral: {
        title: 'Suosittele meitä & ansaitse pisteitä!',
        subtitle: 'Jaa henkilökohtainen koodisi kollegoille. He saavat alennusta ensimmäisestä tilauksesta — ja sinä ansaitset 200 bonuspistettä!',
        step1_title: 'Jaa koodisi', step1_desc: 'WhatsAppin, puhelimen tai kasvotusten',
        step2_title: 'Kollega tilaa', step2_desc: 'Ensimmäisestä tilauksesta alennus',
        step3_title: 'Ansaitset 200 pistettä', step3_desc: 'Automaattisesti hyvitetty tililläsi',
        code_label: 'Henkilökohtainen koodisi', link_label: 'Tai jaa tämä suoralinkki',
        copy_code: 'Kopioi koodi', copy_link: 'Kopioi linkki',
        whatsapp: 'Jaa WhatsAppissa', copied: 'Kopioitu!',
        points_earned_suffix: 'pistettä ansaittu'
      },
      profile: {
        title: 'Täydennä profiilisi', subtitle: 'Ansaitse bonuspisteitä täyttämällä profiilisi',
        save: 'Tallenna', saved: 'Profiili tallennettu!', earned: 'pistettä ansaittu',
        earn: 'pistettä', progress: 'Profiili', select: 'Valitse...',
        other_placeholder: 'Muu, tarkenna...'
      },
      tiers: {
        title: 'Kanta-asiakkuustasot', from: 'Alkaen', points_per: 'pistettä per',
        discount: 'alennus', shipping: 'Ilmainen toimitus', current: 'Tasosi',
        bronze: 'Pronssi', silver: 'Hopea', gold: 'Kulta', platinum: 'Platina'
      },
      guest: {
        title: 'Liity kanta-asiakasohjelmaaan', subtitle: 'Ansaitse pisteitä jokaisesta tilauksesta.',
        login: 'Kirjaudu sisään', how_it_works: 'Miten se toimii',
        step1_title: 'Tilaa & ansaitse', step1_desc: 'Pisteitä jokaisesta ostoksesta',
        step2_title: 'Nouse tasossa', step2_desc: 'Korkeammat tasot, enemmän etuja',
        step3_title: 'Lunasta', step3_desc: 'Käytä pisteitä alennuksiin',
        start_shopping: 'Tee ensimmäinen tilaus ja ala kerätä pisteitä'
      }
    },
    pl: {
      hero: { welcome: 'Witaj ponownie, {name}!', points_label: 'punktów' },
      redeem: {
        title: 'Wymień punkty', subtitle: 'Zamień punkty na zniżkę',
        balance_label: 'Twoje saldo:', quick_label: 'Szybki wybór:', custom_label: 'Lub wpisz własną liczbę:',
        placeholder: 'np. 750', redeem_button: 'Wymień', pts_label: 'pkt',
        insufficient_points: 'Niewystarczająca liczba punktów', min_points_needed: 'Wymagane co najmniej {min} punktów',
        created_message: 'Kod rabatowy utworzony! Użyj tego kodu przy następnym zamówieniu:',
        value_label: 'Wartość:', valid_until_label: 'Ważny do:', connection_error: 'Błąd połączenia:',
        copy_code: 'Kopiuj kod',
        login_required: 'Zaloguj się, aby wymienić punkty',
        confirm_product: 'Czy chcesz wymienić {points} punktów na {title}?',
        processing: 'Przetwarzanie...', adding_to_cart: 'Dodawanie do koszyka...',
        code_prefix: 'Kod: ', add_to_cart_button: 'Dodaj do koszyka',
        redeemed: 'Wymieniono!', your_code_prefix: 'Twój kod: ',
        add_to_cart_manual_button: 'Dodaj samodzielnie do koszyka',
        error_not_logged_in: 'Nie jesteś zalogowany', error_request_expired: 'Żądanie wygasło',
        error_rate_limited: 'Zbyt wiele żądań. Spróbuj ponownie później.',
        error_customer_not_found: 'Nie znaleziono klienta',
        error_member_not_found: 'Nie znaleziono klienta w programie lojalnościowym',
        error_invalid_points: 'Nieprawidłowa liczba punktów', error_points_required: 'Liczba punktów jest wymagana',
        error_product_id_required: 'Produkt jest wymagany', error_referral_code_required: 'Kod polecający jest wymagany',
        error_values_required: 'Dane profilu są wymagane',
        error_product_not_in_collection: 'Nie znaleziono produktu w kolekcji nagród',
        error_product_no_points_price: 'Ten produkt nie ma ceny w punktach',
        error_profile_save_failed: 'Nie udało się zapisać profilu. Spróbuj ponownie później.',
        error_field_expects_boolean: 'Pole \'{field}\' oczekuje wartości \'true\' lub \'false\'',
        error_field_expects_number: 'Pole \'{field}\' oczekuje wartości liczbowej',
        error_b2b_excluded: 'Klienci B2B są wykluczeni z programu lojalnościowego',
        error_max_points_per_redeem: 'Maksymalnie {max} punktów na wymianę',
        insufficient_points_detail: 'Niewystarczająca liczba punktów ({balance} z {needed} wymaganych)'
      },
      history: {
        title: 'Historia punktów', subtitle: 'Twoje ostatnie transakcje punktowe',
        col_date: 'Data', col_desc: 'Opis', col_points: 'Punkty', col_balance: 'Saldo',
        empty: 'Brak transakcji', type_earn: 'Zdobyte', type_redeem: 'Wykorzystane',
        type_adjust: 'Korekta', type_expire: 'Wygasłe'
      },
      rewards: { title: 'Nagrody', subtitle: 'Wymieniaj punkty na produkty', redeem_button: 'Wymień', view_button: 'Zobacz', points_suffix: 'punktów' },
      referral: {
        title: 'Poleć nas & zarabiaj punkty!',
        subtitle: 'Podziel się swoim kodem z kolegami. Otrzymają zniżkę na pierwsze zamówienie — a Ty zarobisz 200 punktów bonusowych!',
        step1_title: 'Podziel się kodem', step1_desc: 'Przez WhatsApp, telefon lub osobiście',
        step2_title: 'Kolega zamawia', step2_desc: 'Ze zniżką na pierwsze zamówienie',
        step3_title: 'Zarabiasz 200 punktów', step3_desc: 'Automatycznie dodane do Twojego konta',
        code_label: 'Twój osobisty kod', link_label: 'Lub udostępnij ten bezpośredni link',
        copy_code: 'Kopiuj kod', copy_link: 'Kopiuj link',
        whatsapp: 'Udostępnij przez WhatsApp', copied: 'Skopiowano!',
        points_earned_suffix: 'punktów zdobytych'
      },
      profile: {
        title: 'Uzupełnij swój profil', subtitle: 'Zdobądź punkty bonusowe, wypełniając swój profil',
        save: 'Zapisz', saved: 'Profil zapisany!', earned: 'punktów zdobytych',
        earn: 'punktów', progress: 'Profil', select: 'Wybierz...',
        other_placeholder: 'Inne, podaj jakie...'
      },
      tiers: {
        title: 'Poziomy lojalnościowe', from: 'Od', points_per: 'punktów za',
        discount: 'zniżki', shipping: 'Darmowa wysyłka', current: 'Twój poziom',
        bronze: 'Brąz', silver: 'Srebro', gold: 'Złoto', platinum: 'Platyna'
      },
      guest: {
        title: 'Dołącz do programu lojalnościowego', subtitle: 'Zdobywaj punkty przy każdym zamówieniu.',
        login: 'Zaloguj się', how_it_works: 'Jak to działa',
        step1_title: 'Zamów & zdobywaj', step1_desc: 'Punkty przy każdym zakupie',
        step2_title: 'Awansuj', step2_desc: 'Wyższe poziomy, więcej korzyści',
        step3_title: 'Wymień', step3_desc: 'Używaj punktów do zniżek',
        start_shopping: 'Złóż pierwsze zamówienie, aby zacząć zbierać punkty'
      }
    }
  };

  // =============================================
  // HELPER FUNCTIONS
  // =============================================

  // SECURITY (F9/F10/F11/F12): escapeHtml() is ALLEEN veilig voor TEKSTINHOUD
  // (waarden die tussen tags terechtkomen, bv. <span>waarde</span>). Het zet
  // textContent en leest innerHTML terug — HTML-tekstnode-serialisatie escapet
  // alleen & < > en NOOIT aanhalingstekens. Gebruik escapeHtml() dus NOOIT voor
  // een waarde die in een HTML-attribuut wordt geplakt (value="...", href="...",
  // data-*="...") — gebruik daarvoor escapeAttr() hieronder. Een waarde met een
  // quote kan anders uit het attribuut breken en een event-handler toevoegen.
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str != null ? String(str) : '';
    return div.innerHTML;
  }

  // SECURITY (F9/F10/F11/F12): escapeAttr() is de ATTRIBUUT-encoder. Gebruik
  // deze voor ELKE waarde die in een HTML-attribuut wordt geconcateneerd en
  // vervolgens met innerHTML/insertAdjacentHTML wordt weggeschreven. In
  // tegenstelling tot escapeHtml() escapet dit ook dubbele en enkele
  // aanhalingstekens en backticks, zodat de waarde nooit het attribuut of een
  // omringende quote (ook in een inline JS-string) kan verlaten.
  function escapeAttr(str) {
    return (str != null ? String(str) : '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/`/g, '&#96;');
  }

  /**
   * Safe text setter — sets textContent; does nothing if el is null.
   */
  function setText(id, text) {
    try {
      var el = document.getElementById(id);
      if (el && text != null) el.textContent = text;
    } catch (e) {}
  }

  /**
   * Get a content field from the config response, falling back to the
   * FALLBACK_CONTENT object for the current language (then NL).
   */
  function getContent(configContent, section, field, lang) {
    try {
      if (configContent && configContent[section] && configContent[section][field] != null) {
        return String(configContent[section][field]);
      }
    } catch (e) {}
    try {
      var fb = FALLBACK_CONTENT[lang] || FALLBACK_CONTENT['nl'];
      if (fb && fb[section] && fb[section][field] != null) return String(fb[section][field]);
    } catch (e) {}
    return '';
  }

  /**
   * Interpolate {name} placeholder in welcome string.
   *
   * BUGFIX (B1): bij een lege customer.first_name (nieuw account, klant heeft
   * geen voornaam ingevuld) gaf een blinde replace altijd "Welcome back, !"
   * — een losse komma vóór het uitroepteken. Behandel de lege naam EXPLICIET:
   * strip het hele ", {name}"-patroon (het komma+spatie-scheidingsteken dat
   * in elke FALLBACK_CONTENT/config-tekst vóór {name} staat) i.p.v. alleen de
   * placeholder zelf, zodat er een grammaticaal correcte zin overblijft
   * ("Welcome back!"). Staat er onverhoopt geen komma vóór {name} (niet het
   * huidige patroon, maar defensief) dan valt dit terug op het kaal
   * verwijderen van de placeholder.
   */
  function interpolateName(str, name) {
    if (!str) return str;
    if (name) return str.replace(/\{name\}/g, escapeHtml(name));
    return str.replace(/[,，]?\s*\{name\}/g, '');
  }

  /**
   * Vult de H1-begroeting + tier-badge-label/discount-label. Vervangt de
   * twee theme-eigen `| t`-vertaalsleutels die HFNA niet heeft (B1,
   * "Translation missing: ..."-bug) door dit JS-gevulde patroon.
   *
   * Wordt TWEE keer aangeroepen:
   *   1. DIRECT bij scriptstart, met configContent=null (dus via getContent()
   *      se fallback op FALLBACK_CONTENT[PAGE_LANG]) — een verdedigbare
   *      beginstaat. Nodig omdat .loyalty-shop pas zichtbaar wordt (CSS:
   *      visibility:hidden -> --ready) nadat de config-fetch resolvet ÓF na
   *      de 3s-failsafe, en bij een TOTALE fetch-mislukking wordt
   *      applyContent() (aanroep 2 hieronder) nooit uitgevoerd — zonder deze
   *      directe fallback-fill zou de kop dan leeg blijven i.p.v. "geen lege
   *      kop die flikkert" (letterlijke opdracht-eis).
   *   2. Vanuit applyContent(), met de ECHTE config-inhoud zodra die
   *      binnenkomt — overschrijft stap 1 met de admin-beheerde tekst.
   */
  function applyHeroAndTierBadge(configContent, lang) {
    function g(section, field) { return getContent(configContent, section, field, lang); }
    try {
      var heroTitle = document.getElementById('loyalty-hero-title');
      if (heroTitle) heroTitle.textContent = interpolateName(g('hero', 'welcome'), CUSTOMER_NAME);
    } catch (e) {}
    try {
      var badgeLabel = document.getElementById('loyalty-tier-badge-label');
      if (badgeLabel) {
        var tierKey = badgeLabel.getAttribute('data-tier') || 'bronze';
        badgeLabel.textContent = g('tiers', tierKey);
      }
      var badgeDiscount = document.getElementById('loyalty-tier-badge-discount-label');
      if (badgeDiscount) badgeDiscount.textContent = g('tiers', 'discount');
    } catch (e) {}
  }

  // Directe fallback-fill — zie functiecommentaar hierboven (aanroep 1/2).
  applyHeroAndTierBadge(null, PAGE_LANG);

  // =============================================
  // CURRENCY / LOCALE FORMATTING
  // =============================================
  // Tenant-valuta-bewuste geldweergave — vervangt hardcoded '€'-string-concatenatie
  // (correct voor happyfarmershop.com/EUR, aantoonbaar FOUT voor
  // happyfarmerna.com/CAD, zie live-bevinding "€1.000" i.p.v. de juiste CAD-notatie).
  // Eén gedeelde helper i.p.v. de format-logica 6x te herhalen.
  //
  // BEWUSTE KEUZE: niet zomaar de kant-en-klare string van
  // Intl.NumberFormat(locale,{style:'currency',currency}).format(amount) gebruiken.
  // Die voegt voor bv. nl-NL een CLDR-literal-spatie toe tussen symbool en bedrag
  // ("€ 1.000" i.p.v. de huidige "€1.000") — een zichtbare regressie op NL die de
  // opdracht expliciet uitsluit. Simpelweg zelf "symbool + getal" concateneren zou
  // dat oplossen voor NL, maar is FOUT voor talen die het symbool ná het bedrag
  // zetten (Frans: "1 000 €", niet "€1 000" — relevant, want happyfarmerna.com
  // serveert zelf een /fr-markt). Oplossing: formatToParts() gebruiken en alleen
  // het LITERAL-part verwijderen dat puur whitespace is (de symbool<->getal-
  // scheiding) — een 'group'-part (duizendtal-scheiding, kan er bij fr ook als
  // spatie uitzien) is een ANDER part-type en blijft altijd staan. Dat reproduceert
  // NL exact ("€1.000") én behoudt de correcte symbool-positie voor elke taal.

  var CURRENCY_SYMBOL_CACHE = {};

  function currencySymbol(locale, currency) {
    var key = locale + '|' + currency;
    if (CURRENCY_SYMBOL_CACHE.hasOwnProperty(key)) return CURRENCY_SYMBOL_CACHE[key];
    var symbol = currency;
    try {
      var parts = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).formatToParts(1);
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'currency') { symbol = parts[i].value; break; }
      }
    } catch (e) {
      // Onbekende/ongeldige currency-code (bv. lege string of typo) — val terug op
      // de rauwe code zelf i.p.v. te crashen; nooit stilzwijgend een fout € tonen.
    }
    CURRENCY_SYMBOL_CACHE[key] = symbol;
    return symbol;
  }

  /**
   * Normaliseert een taal-/locale-string naar de primaire BCP47-subtag die
   * Intl.NumberFormat altijd accepteert (bv. "en-US" -> "en", "NL" -> "nl", een
   * eventuele Noorse "nb"/"nn"-variant blijft gewoon "nb"/"nn" — Intl kent die
   * zelf, in tegenstelling tot de vlakke FALLBACK_CONTENT-taalsleutel-lookup
   * elders in dit bestand die alleen "no" kent). Retourneert null bij
   * afwezige/onbruikbare input, zodat aanroepers hun eigen fallback-keten kunnen
   * toepassen i.p.v. altijd stilzwijgend "nl" terug te krijgen.
   */
  function normalizeLocale(raw) {
    if (!raw || typeof raw !== 'string') return null;
    var primary = raw.split(/[-_]/)[0].toLowerCase();
    return /^[a-z]{2,3}$/.test(primary) ? primary : null;
  }

  /**
   * Bepaalt de te gebruiken locale voor getalnotatie, in volgorde:
   * (1) PAGE_LANG — de taal die Liquid al per-request detecteert
   *     (request.locale.iso_code) en die loyalty-shop.js al voor t_()/getContent()
   *     gebruikt. Preciezer dan één tenant-brede default, want happyfarmerna.com
   *     serveert zelf ook /fr en /en-us naast de tenant-default 'en'.
   * (2) _serverLocale — values.locale van de server (tenants.default_locale),
   *     alleen relevant als PAGE_LANG zelf niet normaliseerbaar bleek.
   * (3) 'nl' als allerlaatste noodgreep (huidig gedrag, ongewijzigd voor NL).
   */
  function resolveLocale() {
    return normalizeLocale(PAGE_LANG) || normalizeLocale(_serverLocale) || 'nl';
  }

  /**
   * Formatteert `amount` als geldbedrag met de juiste symbool-positie per locale
   * (zie toelichting hierboven). `opts` mag elke Intl.NumberFormat-numerieke optie
   * bevatten (typisch minimum/maximumFractionDigits). Bij een lege/onbekende
   * `currency` wordt GEEN symbool getoond — een kaal getal is eerlijker dan een
   * geraden, mogelijk foutief symbool (relevant voor de zeldzame total-outage-
   * situatie, zie _configCurrency-toelichting hierboven).
   */
  function formatMoney(amount, currency, locale, opts) {
    var loc = locale || resolveLocale();
    var value = Number(amount) || 0;
    if (!currency) {
      try { return new Intl.NumberFormat(loc, opts || {}).format(value); }
      catch (e) { return String(Math.round(value)); }
    }
    try {
      var fmtOpts = { style: 'currency', currency: currency };
      if (opts) { for (var k in opts) { if (opts.hasOwnProperty(k)) fmtOpts[k] = opts[k]; } }
      var parts = new Intl.NumberFormat(loc, fmtOpts).formatToParts(value);
      // FIX (code-review 2026-08-12): niet blind ELKE puur-whitespace literal
      // weglaten — dat was taalafhankelijk fout. Voor nl/en staat de literal-spatie
      // tussen een VOORAANGEPLAATST symbool en het getal (weglaten = correct, geeft
      // "€1.000"), maar voor fr staat het symbool NÁ het getal en is diezelfde
      // spatie typografisch verplicht ("1 000 $CA", niet "1 000$CA" — relevant,
      // happyfarmerna.com serveert zelf /fr). Leid de symboolpositie af uit de
      // parts-volgorde (currency-part vóór het eerste integer-part = symbool-vóór-
      // getal) i.p.v. een taalallowlist te verzinnen — werkt voor elke locale die
      // Shopify ooit toevoegt. Alleen de literal DIRECT tussen symbool en getal
      // wordt weggelaten, niet elke andere literal in de string.
      var currencyIdx = -1, firstIntegerIdx = -1;
      for (var i = 0; i < parts.length; i++) {
        if (currencyIdx === -1 && parts[i].type === 'currency') currencyIdx = i;
        if (firstIntegerIdx === -1 && parts[i].type === 'integer') firstIntegerIdx = i;
      }
      var symbolBeforeNumber = currencyIdx !== -1 && firstIntegerIdx !== -1 && currencyIdx < firstIntegerIdx;
      var out = '';
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        var isSymbolNumberGap = symbolBeforeNumber && p.type === 'literal' &&
          j > currencyIdx && j < firstIntegerIdx && /^\s+$/.test(p.value);
        if (isSymbolNumberGap) continue;
        out += p.value;
      }
      return out;
    } catch (e) {
      // formatToParts faalde (bv. ongeldige currency-code) — val terug op de oude
      // NL-vormgeving i.p.v. een kapotte/lege pagina te tonen.
      var num;
      try { num = new Intl.NumberFormat(loc, opts || {}).format(value); }
      catch (e2) { num = String(Math.round(value)); }
      return currencySymbol(loc, currency) + num;
    }
  }

  // =============================================
  // PRESENTMENT-VALUTA CONVERSIE (currency switcher)
  // =============================================
  // Alle bedragen die dit bestand toont zijn PROGRAMMA-PARAMETERS
  // (tier-drempels, punten-waarde, kortingsbedragen) die server-side zijn
  // opgeslagen in de BASISVALUTA (settlement-valuta) van de winkel — dat is
  // wat _configCurrency/tiersCurrency/rewardsCurrency dragen. Sinds de
  // valuta-uitrol toont de rest van de winkel (productprijzen, cart) bedragen
  // in de PRESENTMENT-valuta die de bezoeker zelf koos via de currency
  // switcher (window.Shopify.currency) — onze eigen sectie deed dat tot nu
  // toe niet, met "CA$1.000" i.p.v. het omgerekende "$732" tot gevolg zodra
  // een HFNA-bezoeker naar USD wisselt.
  //
  // Resolutie-volgorde, dezelfde defensieve keten als resolveLocale():
  //   1. window.Shopify.currency.active + .rate — de daadwerkelijk gekozen
  //      presentment-valuta + Shopify's eigen koers (server-berekend, dus
  //      geen eigen wisselkoers-logica nodig of gewenst).
  //   2. fallbackCurrency (de basisvaluta zelf: _configCurrency /
  //      tiersCurrency / rewardsCurrency, per aanroepende sectie), koers 1 —
  //      geen switcher-info beschikbaar, toon de basisvaluta ONGEWIJZIGD.
  //   3. 'EUR', koers 1 — allerlaatste noodgreep (zie _configCurrency-
  //      toelichting hierboven).
  //
  // Ontbreekt window.Shopify.currency, of is .rate geen bruikbaar getal (geen
  // string/number, NaN, of <= 0), dan wordt NOOIT omgerekend — een kaal,
  // niet-omgerekend bedrag in de basisvaluta is eerlijker dan een bedrag met
  // een geraden koers. Op de basismarkt van elke winkel (NL/EUR rate 1.0,
  // CA/CAD rate 1.0) is currency===fallbackCurrency en rate===1, dus is de
  // uitkomst BYTE-IDENTIEK aan vóór deze fix — geen regressie op de gepinde
  // "Vanaf €1.000"-basismarkttekst.
  function resolveCurrency(fallbackCurrency) {
    try {
      var sc = window.Shopify && window.Shopify.currency;
      if (sc && sc.active) {
        var rate = parseFloat(sc.rate);
        if (isFinite(rate) && rate > 0) return { currency: sc.active, rate: rate };
      }
    } catch (e) {}
    return { currency: fallbackCurrency || 'EUR', rate: 1 };
  }

  /**
   * Rekent `amount` (uitgedrukt in de BASISVALUTA, `fallbackCurrency`) om
   * naar de actieve presentment-valuta en formatteert het resultaat via
   * formatMoney() — ONGEWIJZIGD, zie de toelichting daarboven over de
   * symbool-positie-logica (parts-array, currency-index vóór integer-index).
   * Alleen het BEDRAG wordt hier vermenigvuldigd met Shopify's koers; de
   * opmaak zelf blijft volledig aan formatMoney().
   *
   * BUGFIX (live-controle, ronde 2) — LOCALE-KEUZE HOORT BIJ DE VALUTA, NIET
   * BIJ EEN VASTE REGEL: Thomas se bewuste beslissing "getalnotatie volgt de
   * tenant-standaardtaal, niet de paginataal" (regel ~2058 van vóór deze fix,
   * `normalizeLocale(data.locale) || resolveLocale()`) is genomen toen de
   * valuta VAST was — negen EUR-storefronts mochten hun notatie niet zien
   * verspringen. Zodra we omrekenen naar de valuta van de BEZOEKER vervalt die
   * premisse voor precies dát bedrag: een Zweeds bedrag met Nederlandse
   * conventies formatteren (`Intl.NumberFormat('nl',{currency:'SEK'})`) geeft
   * "SEK 10.990" — de ISO-code als symbool (NL rendert een vreemde valuta
   * altijd met de ISO-code, nooit een geraden symbool) MET een Nederlandse
   * duizendtal-punt op een Zweedse pagina. Regel: GEEN conversie toegepast
   * (res.rate === 1, basisvaluta) -> `baseLocale` zoals de aanroeper 'm al
   * bepaalde (tenant-locale voor de tiers-tak, resolveLocale() voor de andere
   * vier plekken — ONGEWIJZIGD, vandaar de regressietest); WEL conversie
   * toegepast -> resolveLocale() (de paginataal), want het bedrag staat dan in
   * de valuta van de bezoeker en hoort de notatie daar ook bij. Op elke
   * basismarkt (rate 1.0) is res.rate===1, dus blijft dit pad BYTE-IDENTIEK
   * aan vóór deze fix.
   */
  function formatConverted(amount, fallbackCurrency, baseLocale, opts) {
    var res = resolveCurrency(fallbackCurrency);
    var converted = (Number(amount) || 0) * res.rate;
    var didConvert = res.rate !== 1;
    var loc = didConvert ? resolveLocale() : (baseLocale || resolveLocale());
    return formatMoney(converted, res.currency, loc, opts);
  }

  // =============================================
  // CONFIG FETCH WITH TIMEOUT
  // =============================================

  var CONFIG_TIMEOUT_MS = 4000; // 4s — fast CDN + Cache-Control:max-age=300

  function fetchConfig(lang) {
    return new Promise(function (resolve, reject) {
      var done = false;
      var timer = setTimeout(function () {
        if (!done) { done = true; reject(new Error('timeout')); }
      }, CONFIG_TIMEOUT_MS);

      fetch(withShopParam(API_URL + '/api/public/loyalty-page-config?lang=' + encodeURIComponent(lang)))
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          if (!done) { done = true; clearTimeout(timer); resolve(data); }
        })
        .catch(function (err) {
          if (!done) { done = true; clearTimeout(timer); reject(err); }
        });
    });
  }

  // =============================================
  // APPLY STYLING (CSS variables)
  // =============================================

  function applyStyling(styling) {
    if (!styling || !shopEl) return;
    try {
      if (styling.primary_color) shopEl.style.setProperty('--loyalty-primary', styling.primary_color);
      if (styling.accent_color) shopEl.style.setProperty('--loyalty-accent', styling.accent_color);
      if (styling.button_text_color) shopEl.style.setProperty('--loyalty-btn-text', styling.button_text_color);
      if (styling.card_radius) shopEl.style.setProperty('--loyalty-radius', styling.card_radius);
      // Derive secondary from primary for gradient if not explicitly set
      // (config has primary_color and accent_color; secondary stays hardcoded unless overridden)
    } catch (e) {}
  }

  // =============================================
  // APPLY PER-SECTION STYLING (CSS vars per wrapper)
  // =============================================

  function applySectionStyling(sections) {
    if (!Array.isArray(sections) || !shopEl) return;
    try {
      sections.forEach(function (s) {
        if (!s || !s.styling) return;

        // Find wrapper: custom sections use id, built-ins use key
        var identifier = (s.type === 'custom') ? s.id : s.key;
        if (!identifier) return;

        var wrapper = shopEl.querySelector('[data-section="' + identifier + '"]');
        if (!wrapper) return;

        var st = s.styling;
        // Only set vars for fields that are explicitly present in styling — empty fields
        // leave the var unset so CSS falls back to the transparent/inherit defaults.
        if (st.background_color) wrapper.style.setProperty('--section-bg', st.background_color);
        if (st.text_color) wrapper.style.setProperty('--section-text', st.text_color);
        if (st.accent_color) wrapper.style.setProperty('--section-accent', st.accent_color);
        if (st.padding_top) wrapper.style.setProperty('--section-pad-top', st.padding_top);
        if (st.padding_bottom) wrapper.style.setProperty('--section-pad-bottom', st.padding_bottom);
        if (st.text_align) wrapper.style.setProperty('--section-text-align', st.text_align);

        // data-width: hero and guest are always full-width; all other sections respect styling.width
        var sectionKey = (s.type === 'custom') ? s.id : s.key;
        var isFullOnly = (sectionKey === 'hero' || sectionKey === 'guest');
        var width = (!isFullOnly && st.width === 'half') ? 'half' : 'full';
        wrapper.setAttribute('data-width', width);
      });
    } catch (e) {}
  }

  // =============================================
  // RENDER CUSTOM SECTIONS (type=custom)
  // =============================================

  /**
   * Validate a URL is safe (http/https only) to prevent javascript: XSS.
   * Returns the validated href string, or null if invalid/unsafe.
   */
  function safeUrl(url) {
    if (!url || typeof url !== 'string') return null;
    try {
      var parsed = new URL(url);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function renderCustomSections(sections) {
    if (!Array.isArray(sections) || !shopEl) return;
    try {
      sections.forEach(function (s) {
        if (!s || s.type !== 'custom' || !s.id) return;

        // Skip if already in the DOM
        if (shopEl.querySelector('[data-section="' + s.id + '"]')) return;

        var content = s.content || {};

        // Create wrapper — hidden initially to avoid FOUC while styling is applied
        var div = document.createElement('div');
        div.className = 'loyalty-section loyalty-section--custom';
        div.setAttribute('data-section', s.id);
        // Hide until applySectionStyling has run (caller sets display after)
        div.style.visibility = 'hidden';

        // Title (XSS-safe: textContent only)
        if (content.title) {
          var h2 = document.createElement('h2');
          h2.className = 'loyalty-section__title loyalty-section--custom__title';
          h2.textContent = content.title;
          div.appendChild(h2);
        }

        // Subtitle
        if (content.subtitle) {
          var p = document.createElement('p');
          p.className = 'loyalty-section__subtitle loyalty-section--custom__subtitle';
          p.textContent = content.subtitle;
          div.appendChild(p);
        }

        // Body — white-space:pre-wrap via CSS; textContent is XSS-safe
        if (content.body) {
          var bodyDiv = document.createElement('div');
          bodyDiv.className = 'loyalty-section--custom__body';
          bodyDiv.textContent = content.body;
          div.appendChild(bodyDiv);
        }

        // Image — only if URL passes http/https validation
        if (content.image_url) {
          var validSrc = safeUrl(content.image_url);
          if (validSrc) {
            var img = document.createElement('img');
            img.className = 'loyalty-section--custom__image';
            img.src = validSrc;
            // alt via textContent assignment (XSS-safe)
            img.alt = content.image_alt || '';
            img.loading = 'lazy';
            div.appendChild(img);
          }
        }

        shopEl.appendChild(div);
      });
    } catch (e) {}
  }

  // =============================================
  // APPLY SECTION VISIBILITY + ORDER
  // =============================================

  function applySections(sections) {
    if (!Array.isArray(sections) || !shopEl) return;
    try {
      // Sort by order ascending
      var sorted = sections.slice().sort(function (a, b) { return (a.order || 0) - (b.order || 0); });

      // Build two maps: key → section (built-ins) and id → section (custom + built-ins with id)
      var sectionMap = {};
      var sectionById = {};
      sorted.forEach(function (s) {
        if (s.key) sectionMap[s.key] = s;
        if (s.id) sectionById[s.id] = s;
      });

      // Find all section containers in the DOM
      var sectionEls = shopEl.querySelectorAll('[data-section]');

      // byKey maps each section identifier to an ARRAY of elements (multiple elements per key
      // allowed, e.g. guest hero + guest_info both use data-section="guest").
      var byKey = {};
      sectionEls.forEach(function (el) {
        var key = el.getAttribute('data-section');
        if (!byKey[key]) byKey[key] = [];
        byKey[key].push(el);
      });

      // Show/hide ALL elements for each section based on enabled flag.
      // Built-ins match by key; custom sections match by id.
      sorted.forEach(function (s) {
        var identifier = (s.type === 'custom') ? s.id : s.key;
        var els = byKey[identifier];
        if (!els) return;
        var display = s.enabled === false ? 'none' : '';
        els.forEach(function (el) {
          el.style.display = display;
          // Reveal custom sections that were hidden during construction
          if (s.type === 'custom') el.style.visibility = '';
        });
      });

      // -----------------------------------------------
      // RE-ORDER DIRECT CHILDREN OF .loyalty-shop
      // -----------------------------------------------
      // The DOM contains a .loyalty-two-col wrapper that has NO data-section itself
      // but wraps the redeem + history sections as children. The old parentGroups
      // approach only repositioned [data-section] elements within their parent,
      // which caused the two-col wrapper (not a [data-section] node) to stay put
      // while direct [data-section] children (including hero) got appended after it.
      //
      // Fix: treat every direct child of shopEl as an orderable unit:
      //   - direct child WITH data-section  → use that section's order value
      //   - direct child WITHOUT data-section but containing [data-section] descendants
      //     (i.e. the two-col wrapper) → use the MINIMUM order of those descendants
      //   - direct child with no data-section and no nested data-sections → keep as-is
      //     (assigned a high sentinel so it naturally falls to the end)
      //
      // Then stable-sort and re-append all direct children in the resolved order.

      var directChildren = Array.prototype.slice.call(shopEl.children);

      // Helper: look up section data by data-section attribute value (key or id)
      function getSectionData(attrVal) {
        return sectionMap[attrVal] || sectionById[attrVal] || null;
      }

      // Assign an effective order to each direct child
      var childOrders = directChildren.map(function (child) {
        var ownKey = child.getAttribute('data-section');
        if (ownKey) {
          var sd = getSectionData(ownKey);
          if (sd) return { el: child, order: sd.order || 0 };
        }
        // No own data-section — look for nested [data-section] descendants
        var nested = child.querySelectorAll('[data-section]');
        if (nested.length > 0) {
          var minOrder = Infinity;
          nested.forEach(function (n) {
            var nKey = n.getAttribute('data-section');
            var nsd = getSectionData(nKey);
            if (nsd) {
              var o = nsd.order || 0;
              if (o < minOrder) minOrder = o;
            }
          });
          if (minOrder !== Infinity) {
            return { el: child, order: minOrder };
          }
        }
        // No orderable data at all — use a high sentinel to keep original relative position
        return { el: child, order: 9999 };
      });

      // Stable sort: Array.sort is stable in all modern browsers (ES2019+)
      childOrders.sort(function (a, b) { return a.order - b.order; });

      // Re-append direct children in resolved order
      childOrders.forEach(function (item) {
        try { shopEl.appendChild(item.el); } catch (e) {}
      });

      // -----------------------------------------------
      // RE-ORDER WITHIN .loyalty-two-col (redeem/history)
      // -----------------------------------------------
      // Order the two-col's direct [data-section] children by their own order values.
      var twoCol = shopEl.querySelector('.loyalty-two-col');
      if (twoCol) {
        var twoColSections = Array.prototype.slice.call(
          twoCol.querySelectorAll(':scope > [data-section]')
        );
        if (twoColSections.length > 1) {
          twoColSections.sort(function (a, b) {
            var aKey = a.getAttribute('data-section');
            var bKey = b.getAttribute('data-section');
            var aOrder = (sectionMap[aKey] && sectionMap[aKey].order) || 0;
            var bOrder = (sectionMap[bKey] && sectionMap[bKey].order) || 0;
            return aOrder - bOrder;
          });
          twoColSections.forEach(function (el) {
            try { twoCol.appendChild(el); } catch (e) {}
          });
        }
      }
    } catch (e) {}
  }

  // =============================================
  // APPLY CONTENT TEXTS
  // =============================================

  function applyContent(content, lang, sections) {
    // content may be null/undefined when only custom sections are present
    // sections is optional — used to apply inline content for type=custom sections

    // Apply inline content for custom sections (content already resolved per-lang by backend)
    if (Array.isArray(sections)) {
      sections.forEach(function (s) {
        if (!s || s.type !== 'custom' || !s.id || !s.content) return;
        var wrapper = shopEl && shopEl.querySelector('[data-section="' + s.id + '"]');
        if (!wrapper) return;

        var c = s.content;

        // Title
        var titleEl = wrapper.querySelector('.loyalty-section--custom__title');
        if (titleEl && c.title != null) titleEl.textContent = c.title;

        // Subtitle
        var subtitleEl = wrapper.querySelector('.loyalty-section--custom__subtitle');
        if (subtitleEl && c.subtitle != null) subtitleEl.textContent = c.subtitle;

        // Body
        var bodyEl = wrapper.querySelector('.loyalty-section--custom__body');
        if (bodyEl && c.body != null) bodyEl.textContent = c.body;

        // Image — re-validate URL (defence in depth in case renderCustomSections was skipped)
        var imgEl = wrapper.querySelector('.loyalty-section--custom__image');
        if (imgEl && c.image_url) {
          var validSrc = safeUrl(c.image_url);
          if (validSrc) {
            imgEl.src = validSrc;
            imgEl.alt = c.image_alt || '';
          }
        }
      });
    }

    if (!content) return;

    function g(section, field) { return getContent(content, section, field, lang); }

    try {
      // HERO — H1 + tier-badge worden door dezelfde helper gevuld als de
      // directe boot-time fallback (zie applyHeroAndTierBadge()), nu met de
      // ECHTE config-inhoud i.p.v. FALLBACK_CONTENT.
      applyHeroAndTierBadge(content, lang);
      setText('loyalty-hero-points-label', g('hero', 'points_label'));

      // REDEEM section headings
      setText('loyalty-redeem-title', g('redeem', 'title'));
      setText('loyalty-redeem-subtitle', g('redeem', 'subtitle'));
      // Widget labels (inside loyalty-points-widget.liquid)
      var balanceEl = document.getElementById('loyalty-redeem-balance');
      if (balanceEl) {
        var balanceLabel = g('redeem', 'balance_label');
        var balancePtsLabel = document.getElementById('loyalty-redeem-balance-pts-label');
        var balanceLabelNode = balanceEl.firstChild;
        // Replace the static label text node (first text node before the value span)
        if (balanceLabel && balanceLabelNode) {
          balanceLabelNode.textContent = balanceLabel + ' ';
        }
        if (balancePtsLabel) balancePtsLabel.textContent = g('redeem', 'pts_label') || '';
      }
      setText('loyalty-redeem-quick-label', g('redeem', 'quick_label'));
      setText('loyalty-redeem-custom-label', g('redeem', 'custom_label'));
      var customInput = document.getElementById('loyalty-custom-points');
      if (customInput && g('redeem', 'placeholder')) customInput.placeholder = g('redeem', 'placeholder');
      setText('loyalty-redeem-btn-text', g('redeem', 'redeem_button'));

      // HISTORY section headings
      setText('loyalty-history-title', g('history', 'title'));
      setText('loyalty-history-subtitle', g('history', 'subtitle'));
      // History data-t-* attributes are set by Liquid and read by the history renderer below.
      // We update them so the dynamic renderer uses the config strings.
      var historyEl = document.getElementById('loyalty-history');
      if (historyEl) {
        var hFields = ['date', 'desc', 'points', 'balance', 'empty', 'earn', 'redeem', 'adjust', 'expire'];
        var hMap = {
          date: 'col_date', desc: 'col_desc', points: 'col_points', balance: 'col_balance',
          empty: 'empty', earn: 'type_earn', redeem: 'type_redeem', adjust: 'type_adjust', expire: 'type_expire'
        };
        hFields.forEach(function (k) {
          var v = g('history', hMap[k]);
          if (v) historyEl.setAttribute('data-t-' + k, v);
        });
      }

      // REWARDS section headings
      setText('loyalty-rewards-title', g('rewards', 'title'));
      setText('loyalty-rewards-subtitle', g('rewards', 'subtitle'));
      // Reward card button texts
      document.querySelectorAll('.loyalty-rewards-redeem-btn-text').forEach(function (el) {
        el.textContent = g('rewards', 'redeem_button') || el.textContent;
      });
      document.querySelectorAll('.loyalty-rewards-view-btn-text').forEach(function (el) {
        el.textContent = g('rewards', 'view_button') || el.textContent;
      });
      // Reward card points suffix (e.g. "punten" / "Punkte" / "points")
      var ptsSuffix = g('rewards', 'points_suffix');
      if (ptsSuffix) {
        document.querySelectorAll('.loyalty-reward-card__pts-label').forEach(function (el) {
          el.textContent = ptsSuffix;
        });
      }

      // REFERRAL section
      setText('loyalty-referral-title', g('referral', 'title'));
      setText('loyalty-referral-subtitle', g('referral', 'subtitle'));
      setText('loyalty-referral-step1-title', g('referral', 'step1_title'));
      setText('loyalty-referral-step1-desc', g('referral', 'step1_desc'));
      setText('loyalty-referral-step2-title', g('referral', 'step2_title'));
      setText('loyalty-referral-step2-desc', g('referral', 'step2_desc'));
      setText('loyalty-referral-step3-title', g('referral', 'step3_title'));
      setText('loyalty-referral-step3-desc', g('referral', 'step3_desc'));
      setText('loyalty-referral-code-label', g('referral', 'code_label'));
      setText('loyalty-referral-link-label', g('referral', 'link_label'));
      setText('loyalty-referral-copy-code-text', g('referral', 'copy_code'));
      setText('loyalty-referral-copy-link-text', g('referral', 'copy_link'));
      setText('loyalty-referral-whatsapp-text', g('referral', 'whatsapp'));
      // Store copied text on the share container as data attribute for inline onclick
      var refShare = document.getElementById('loyalty-referral-share');
      if (refShare && g('referral', 'copied')) refShare.setAttribute('data-t-copied', g('referral', 'copied'));

      // PROFILE section
      setText('loyalty-profile-title', g('profile', 'title'));
      setText('loyalty-profile-subtitle', g('profile', 'subtitle'));
      // Update data-t-* on the profile form element so the dynamic form renderer uses these
      var profileForm = document.getElementById('loyalty-profile-form');
      if (profileForm) {
        var pfMap = { save: 'save', saved: 'saved', earned: 'earned', earn: 'earn', progress: 'progress', select: 'select' };
        Object.keys(pfMap).forEach(function (attr) {
          var v = g('profile', pfMap[attr]);
          if (v) profileForm.setAttribute('data-t-' + attr, v);
        });
      }

      // TIERS section heading
      setText('loyalty-tiers-title', g('tiers', 'title'));
      // Update tiers grid data-t-* attributes for the tier renderer
      var tiersGrid = document.getElementById('loyalty-tiers-grid');
      if (tiersGrid) {
        var tMap = { from: 'from', points: 'points_per', discount: 'discount', shipping: 'shipping', current: 'current',
                     bronze: 'bronze', silver: 'silver', gold: 'gold', platinum: 'platinum' };
        Object.keys(tMap).forEach(function (attr) {
          var v = g('tiers', tMap[attr]);
          if (v) tiersGrid.setAttribute('data-t-' + attr, v);
        });
      }

      // MY REWARDS section headings + data-t-* attrs
      setText('loyalty-my-rewards-title', g('my_rewards', 'title'));
      setText('loyalty-my-rewards-subtitle', g('my_rewards', 'subtitle'));
      var myRewardsEl = document.getElementById('loyalty-my-rewards');
      if (myRewardsEl) {
        var mrFields = ['status_active','status_used','status_expired','expires_label','used_label','copy_button','copied','apply_button','empty','points_label','product_only_label','product_only_generic'];
        mrFields.forEach(function (k) {
          var v = g('my_rewards', k);
          if (v) myRewardsEl.setAttribute('data-t-' + k, v);
        });
      }

      // GUEST section
      setText('loyalty-guest-title', g('guest', 'title'));
      setText('loyalty-guest-subtitle', g('guest', 'subtitle'));
      setText('loyalty-guest-login-text', g('guest', 'login'));
      // Ingelogde niet-member CTA (element ontbreekt in uitgelogde-modus — setText is dan no-op)
      setText('loyalty-guest-shop-text', g('guest', 'start_shopping'));
      setText('loyalty-guest-how-title', g('guest', 'how_it_works'));
      setText('loyalty-guest-step1-title', g('guest', 'step1_title'));
      setText('loyalty-guest-step1-desc', g('guest', 'step1_desc'));
      setText('loyalty-guest-step2-title', g('guest', 'step2_title'));
      setText('loyalty-guest-step2-desc', g('guest', 'step2_desc'));
      setText('loyalty-guest-step3-title', g('guest', 'step3_title'));
      setText('loyalty-guest-step3-desc', g('guest', 'step3_desc'));
    } catch (e) {}
  }

  // =============================================
  // APPLY REDEEM TIERS (quick-select buttons)
  // =============================================

  function applyRedeemTiers(values) {
    try {
      var tiers = (values && Array.isArray(values.redeem_tiers) && values.redeem_tiers.length > 0)
        ? values.redeem_tiers : FALLBACK_REDEEM_TIERS;
      // Servercontract-veldnaam points_per_eur_discount blijft bewust ongewijzigd
      // (de live NL-theme leest die sleutel al) — alleen de lokale variabele-/
      // constante-naam is valuta-neutraal gemaakt (ptsPerEur -> ptsPerUnit).
      var ptsPerUnit = (values && values.points_per_eur_discount > 0)
        ? values.points_per_eur_discount : FALLBACK_POINTS_PER_UNIT;
      var minRedeem = (values && values.min_redeem_points > 0)
        ? values.min_redeem_points : FALLBACK_MIN_REDEEM;

      // Update POINTS_PER_UNIT used by custom input preview
      window.__loyaltyPtsPerUnit = ptsPerUnit;
      window.__loyaltyMinRedeem = minRedeem;

      // Update custom input min attribute
      var customInput = document.getElementById('loyalty-custom-points');
      if (customInput) customInput.min = minRedeem;

      var widget = document.getElementById('loyalty-redeem-widget');
      var currentPoints = widget ? (parseInt(widget.getAttribute('data-points')) || 0) : 0;

      var btnsContainer = document.getElementById('loyalty-redeem-quick-buttons');
      if (!btnsContainer) return;

      // Get pts_label from widget balance-pts-label
      var ptsLabelEl = document.getElementById('loyalty-redeem-balance-pts-label');
      var ptsLabel = ptsLabelEl ? ptsLabelEl.textContent : 'ptn';

      // Build new buttons
      var html = '';
      // redeemLocale = de "geen conversie"-locale (paginataal) die formatConverted()
      // gebruikt zolang er niet daadwerkelijk is omgerekend; zodra de bezoeker via de
      // switcher WEL een andere presentment-valuta koos, overschrijft formatConverted()
      // dit zelf met resolveLocale() — hier toevallig dezelfde waarde, zie de
      // toelichting bij formatConverted().
      var redeemLocale = resolveLocale();
      tiers.forEach(function (pts) {
        // {minimumFractionDigits:0, maximumFractionDigits:2} reproduceert exact het
        // oude .toFixed(2).replace(/\.00$/,'') gedrag (hele bedragen zonder ",00"),
        // maar dan met een correcte, locale-afhankelijke decimaalscheiding i.p.v.
        // altijd een punt.
        var amountText = formatConverted(pts / ptsPerUnit, _configCurrency, redeemLocale,
          { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        var disabled = currentPoints < pts ? ' disabled' : '';
        html += '<button class="loyalty-btn loyalty-btn--outline loyalty-redeem-btn"' +
          ' data-points="' + pts + '"' + disabled + '>' +
          pts + ' ' + escapeHtml(ptsLabel) + ' = ' + escapeHtml(amountText) +
          '</button>';
      });
      btnsContainer.innerHTML = html;

      // Re-wire click handlers on new buttons
      btnsContainer.querySelectorAll('.loyalty-redeem-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pts = parseInt(this.getAttribute('data-points'));
          redeemPoints(pts);
        });
      });

      // Update custom redeem button disabled state
      var customBtn = document.getElementById('loyalty-redeem-custom-btn');
      if (customBtn) customBtn.disabled = currentPoints < minRedeem;
    } catch (e) {}
  }

  // =============================================
  // APPLY FOOTER LINKS
  // =============================================

  function applyLinks(links) {
    try {
      var footerEl = document.getElementById('loyalty-footer-links');
      if (!footerEl) return;
      if (!Array.isArray(links) || links.length === 0) { footerEl.style.display = 'none'; return; }

      var footerLinks = links.filter(function (l) { return l.location === 'footer'; });
      if (footerLinks.length === 0) { footerEl.style.display = 'none'; return; }

      footerLinks.forEach(function (link) {
        try {
          var url = link.url || '';
          // Defense-in-depth: only allow http/https URLs — skip anything else (javascript:, data:, etc.)
          if (!url.match(/^https?:\/\//i)) return;
          var a = document.createElement('a');
          // label is already resolved per-lang by the backend; use textContent (no innerHTML)
          a.textContent = link.label || '';
          a.href = url;
          a.target = '_blank';
          a.rel = 'noopener noreferrer';
          footerEl.appendChild(a);
        } catch (e) {}
      });
    } catch (e) {}
  }

  // =============================================
  // CONFIG APPLY ORCHESTRATOR
  // =============================================

  function applyConfig(config) {
    if (!config) return;
    // 0. Onthoud content/taal/valuta in module-state, ook bruikbaar BUITEN deze
    //    functie (bv. redeemPoints()/showResult(), die pas draaien ná een latere
    //    gebruikersactie, ver buiten deze closure). Nieuw: config.values.currency
    //    / config.values.locale (additief servercontract, bestaande velden zoals
    //    points_per_eur_discount blijven exact zoals ze heetten).
    try {
      _configContent = config.content || null;
      _configLang = config.lang || PAGE_LANG;
      if (config.values && config.values.currency) _configCurrency = config.values.currency;
      if (config.values && config.values.locale) _serverLocale = config.values.locale;
    } catch (e) {}
    // 1. Global CSS vars (primary_color, accent_color, etc.) — serve as fallback for all sections
    try { applyStyling(config.styling); } catch (e) {}
    // 2. Per-section CSS-var overrides (--section-bg, --section-text, …) on existing wrappers
    try { applySectionStyling(config.sections); } catch (e) {}
    // 3. Render custom sections that are not yet in the DOM (appended to .loyalty-shop)
    try { renderCustomSections(config.sections); } catch (e) {}
    // 4. Apply styling to newly created custom-section wrappers
    try { applySectionStyling(config.sections); } catch (e) {}
    // 5. Apply content texts for built-in sections (+ custom content handled inside)
    try { applyContent(config.content, config.lang || PAGE_LANG, config.sections); } catch (e) {}
    // 6. Quick-select redeem tier buttons
    try { applyRedeemTiers(config.values); } catch (e) {}
    // 7. Show/hide + reorder all sections (built-in + custom), reveal hidden custom elements
    try { applySections(config.sections); } catch (e) {}
    // 8. Footer links
    try { applyLinks(config.links); } catch (e) {}
  }

  // =============================================
  // BOOT: fetch config then apply
  // The page already shows correct Liquid defaults.
  // We progressively enhance after a successful fetch.
  // =============================================

  fetchConfig(PAGE_LANG)
    .then(function (config) {
      applyConfig(config);
      if (window._loyaltyConfigResolve) { window._loyaltyConfigResolve(); window._loyaltyConfigResolve = null; }
      var rootEl = document.querySelector('.loyalty-shop');
      if (rootEl) rootEl.classList.add('loyalty-shop--ready');
    })
    .catch(function () {
      // Config fetch failed or timed out.
      // Page already shows correct Liquid server-side content — no action needed.
      // Still apply the JS fallback values for dynamic parts (tiers/minRedeem/ptsPerUnit).
      try { applyRedeemTiers(null); } catch (e) {}
      if (window._loyaltyConfigResolve) { window._loyaltyConfigResolve(); window._loyaltyConfigResolve = null; }
      var rootEl = document.querySelector('.loyalty-shop');
      if (rootEl) rootEl.classList.add('loyalty-shop--ready');
    });

  // =============================================
  // REDEEM WIDGET — CORE LOGIC
  // (unchanged from original; uses window.__loyaltyPtsPerUnit)
  // =============================================

  // Custom input preview
  var customInput = document.getElementById('loyalty-custom-points');
  var preview = document.getElementById('loyalty-discount-preview');

  if (customInput && preview) {
    customInput.addEventListener('input', function () {
      var pts = parseInt(this.value) || 0;
      var ptsPerUnit = window.__loyaltyPtsPerUnit || FALLBACK_POINTS_PER_UNIT;
      var minRedeem = window.__loyaltyMinRedeem || FALLBACK_MIN_REDEEM;
      if (pts >= minRedeem) {
        // minimumFractionDigits:2 reproduceert exact het oude .toFixed(2) (altijd
        // 2 decimalen, nooit getrimd) — alleen symbool + decimaalscheiding zijn nu
        // valuta-/locale-bewust i.p.v. een hardcoded '€' + punt-als-komma.
        preview.textContent = '= ' + formatConverted(pts / ptsPerUnit, _configCurrency, resolveLocale(),
          { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } else {
        preview.textContent = '';
      }
    });
  }

  // Quick select buttons — initial wiring (before config fetch replaces them)
  var quickBtns = document.querySelectorAll('.loyalty-redeem-btn');
  quickBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pts = parseInt(this.getAttribute('data-points'));
      redeemPoints(pts);
    });
  });

  /**
   * Generieke content-lookup voor een willekeurige FALLBACK_CONTENT-sectie.
   * Leest per-taal strings via getContent() — dezelfde fallback-keten als de
   * rest van dit bestand (server-content -> FALLBACK_CONTENT[lang] ->
   * sleutelnaam zelf). Nodig omdat sommige aanroepers (redeemPoints(),
   * showResult(), de reward-product-redeem-flow, de foutcode-vertaling)
   * draaien ná een latere gebruikersactie, ver buiten de closure van
   * applyContent() — vandaar de module-state _configContent/_configLang (zie
   * applyConfig()) i.p.v. een lokale `content`/`lang`-parameter.
   */
  function ct(section, key) {
    return getContent(_configContent, section, key, _configLang) || key;
  }

  /**
   * rt() = ct('redeem', key) — behouden als losse naam voor de bestaande
   * aanroepen (het redeem-succes-/foutpad, B2's product-redeem-strings).
   */
  function rt(key) {
    return ct('redeem', key);
  }

  // =============================================
  // B3 — SERVER-FOUTCODES VERTALEN
  // =============================================
  // Servercontract sinds Deel B3: elk foutantwoord van /api/storefront/* (via
  // de Shopify App Proxy op PROXY_BASE) draagt naast het bestaande `error`
  // (rauwe, altijd-Nederlandse tekst) een stabiele `code`, en waar nodig
  // `params` (zie server/routes/storefront.js#errorBody()). Voorheen toonde
  // showError(data.error)/statusEl.textContent=result.error deze rauwe
  // Nederlandse tekst rechtstreeks aan ELKE klant, ongeacht taal.
  //
  // insufficient_points hergebruikt de AL BESTAANDE FALLBACK_CONTENT-sleutel
  // (géén duplicaat) — die sleutel wordt ook door een zuiver CLIENT-SIDE
  // check gebruikt (redeemPoints(), points > currentPoints, vóór er ooit een
  // server-call is) en heeft daarom BEWUST geen {balance}/{needed}-placeholder
  // in de tekst zelf: die client-side aanroep doet geen placeholder-
  // substitutie, en zou een letterlijke "{balance}" tonen als de gedeelde
  // tekst die placeholder wél bevatte. De server-kant (translateApiError()
  // hieronder) krijgt sinds de POST /redeem(-product)-uitbreiding een APARTE
  // detailsleutel (insufficient_points_detail, MET {balance}/{needed}) die
  // alleen gebruikt wordt als beide params bruikbare getallen zijn — anders
  // valt hij terug op dezelfde kale, sleutel-gedeelde tekst als de
  // client-side check. Zo bestaat er precies ÉÉN "geen punten"-basistekst per
  // taal i.p.v. twee bijna-identieke die uit elkaar kunnen gaan lopen, en
  // nooit een letterlijke "{balance}"/"{needed}" op het scherm.
  //
  // min_points_required (nieuw, POST /redeem-uitbreiding) is semantisch
  // IDENTIEK aan de al bestaande min_points_needed (client-side pre-check,
  // vorige ronde, zelfde {min}-placeholder) — bewust HERGEBRUIKT i.p.v. een
  // bijna-dubbele sleutel toegevoegd, om dezelfde reden als hierboven.
  //
  // field_expects_boolean/-number/max_points_per_redeem/b2b_excluded komen
  // uitsluitend via een ECHTE serverrespons binnen (altijd via
  // translateApiError()), dus die MOGEN wél een eigen {veld}-placeholder in
  // de tekst dragen zonder het client-side-pad te raken.
  var ERROR_CODE_KEYS = {
    not_logged_in: 'error_not_logged_in',
    request_expired: 'error_request_expired',
    rate_limited: 'error_rate_limited',
    customer_not_found: 'error_customer_not_found',
    member_not_found: 'error_member_not_found',
    invalid_points: 'error_invalid_points',
    points_required: 'error_points_required',
    product_id_required: 'error_product_id_required',
    referral_code_required: 'error_referral_code_required',
    values_required: 'error_values_required',
    product_not_in_collection: 'error_product_not_in_collection',
    product_no_points_price: 'error_product_no_points_price',
    profile_save_failed: 'error_profile_save_failed',
    insufficient_points: 'insufficient_points',
    field_expects_boolean: 'error_field_expects_boolean',
    field_expects_number: 'error_field_expects_number',
    b2b_excluded: 'error_b2b_excluded',
    min_points_required: 'min_points_needed',
    max_points_per_redeem: 'error_max_points_per_redeem'
  };

  /**
   * Vertaalt een serverfoutrespons { error, code, params } naar de taal van de
   * bezoeker via rt()/FALLBACK_CONTENT['redeem'] — valt terug op de rauwe
   * data.error bij een ONBEKENDE code (nieuwe/toekomstige servercodes, of een
   * oudere serverversie die nog geen code meestuurt) zodat er NOOIT een lege
   * foutmelding verschijnt.
   */
  function translateApiError(data) {
    if (!data) return '';
    var raw = data.error != null ? String(data.error) : '';
    var code = data.code;
    if (!code || !ERROR_CODE_KEYS.hasOwnProperty(code)) return raw;

    // insufficient_points: alleen de detailtekst (met cijfers) tonen als
    // BEIDE params bruikbare getallen zijn — anders defensief terugvallen op
    // de kale tekst zonder cijfers (nooit letterlijke accolades op het
    // scherm, ook niet bij ontbrekende/onvolledige params).
    if (code === 'insufficient_points') {
      var p = data.params;
      var balanceOk = p && isFinite(Number(p.balance));
      var neededOk = p && isFinite(Number(p.needed));
      if (balanceOk && neededOk) {
        var detail = rt('insufficient_points_detail');
        if (detail !== 'insufficient_points_detail') {
          return detail.replace('{balance}', p.balance).replace('{needed}', p.needed);
        }
      }
      return rt('insufficient_points');
    }

    var key = ERROR_CODE_KEYS[code];
    var text = rt(key);
    // rt() valt terug op de sleutelnaam zelf als noch config noch
    // FALLBACK_CONTENT 'm kent — behandel dat identiek aan "onbekende code".
    if (text === key) return raw || text;
    if (data.params) {
      Object.keys(data.params).forEach(function (p) {
        text = text.replace(new RegExp('\\{' + p + '\\}', 'g'), data.params[p]);
      });
    }
    return text;
  }

  // Custom redeem button
  var customBtn = document.getElementById('loyalty-redeem-custom-btn');
  if (customBtn) {
    customBtn.addEventListener('click', function () {
      var pts = parseInt(customInput ? customInput.value : '0') || 0;
      var minRedeem = window.__loyaltyMinRedeem || FALLBACK_MIN_REDEEM;
      if (pts < minRedeem) {
        showError(rt('min_points_needed').replace('{min}', minRedeem));
        return;
      }
      redeemPoints(pts);
    });
  }

  function redeemPoints(points) {
    var widget = document.getElementById('loyalty-redeem-widget');
    var currentPoints = parseInt(widget ? widget.getAttribute('data-points') : '0');

    if (points > currentPoints) {
      showError(rt('insufficient_points'));
      return;
    }

    setButtonsDisabled(true);
    hideResult();
    hideError();

    fetch(PROXY_BASE + '/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ points: points })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.error) {
          showError(translateApiError(data));
          setButtonsDisabled(false);
          return;
        }

        // minimumFractionDigits:2 reproduceert exact het oude .toFixed(2) (altijd
        // 2 decimalen). Alleen symbool + decimaalscheiding zijn nu valuta-/
        // locale-bewust i.p.v. een hardcoded '€' + punt-als-komma.
        var valueText = rt('value_label') + ' ' + formatConverted(data.discount_value || 0, _configCurrency, resolveLocale(),
          { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var validText = rt('valid_until_label') + ' ' +
          (data.expires_at ? new Date(data.expires_at).toLocaleDateString() : '-');

        showResult(
          rt('created_message'),
          data.discount_code,
          valueText + ' — ' + validText
        );

        var newBalance = data.new_balance != null ? data.new_balance : (currentPoints - points);

        var pointsEl = document.querySelector('.loyalty-hero__points-value');
        if (pointsEl) pointsEl.textContent = newBalance;

        var balanceValueEl = document.getElementById('loyalty-redeem-balance-value');
        if (balanceValueEl) balanceValueEl.textContent = newBalance;

        if (customInput) customInput.max = newBalance;
        if (widget) widget.setAttribute('data-points', newBalance);
        updateButtonStates(newBalance);
      })
      .catch(function (err) {
        showError(rt('connection_error') + ' ' + err.message);
        setButtonsDisabled(false);
      });
  }

  // SECURITY (F11): voorheen bouwde deze functie de knop als een innerHTML-string
  // met een inline onclick="navigator.clipboard.writeText('<code>')" — de code
  // stond in een single-quoted JS-string BINNEN een double-quoted HTML-attribuut,
  // en escapeHtml() escapet geen quotes. Een kortingscode-prefix met een quote
  // erin kon zowel het attribuut als de JS-string doorbreken. DOM-constructie met
  // een closure over `code` sluit dit volledig uit — er wordt geen HTML meer
  // geparsed voor deze waarden.
  function showResult(message, code, detail) {
    var el = document.getElementById('loyalty-redeem-result');
    if (!el) return;
    el.innerHTML = '';

    el.appendChild(document.createTextNode(message != null ? String(message) : ''));

    var codeEl = document.createElement('code');
    codeEl.textContent = code != null ? String(code) : '';
    el.appendChild(codeEl);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'loyalty-btn loyalty-btn--secondary';
    btn.style.marginTop = '8px';
    btn.textContent = rt('copy_code');
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(code);
    });
    el.appendChild(btn);

    if (detail) {
      var detailEl = document.createElement('p');
      detailEl.style.marginTop = '8px';
      detailEl.style.fontSize = '12px';
      detailEl.style.opacity = '0.8';
      detailEl.textContent = detail;
      el.appendChild(detailEl);
    }

    el.style.display = 'block';
  }

  function showError(msg) {
    var el = document.getElementById('loyalty-redeem-error');
    if (!el) return;
    el.textContent = msg;
    el.style.display = 'block';
  }

  function hideResult() {
    var el = document.getElementById('loyalty-redeem-result');
    if (el) el.style.display = 'none';
  }

  function hideError() {
    var el = document.getElementById('loyalty-redeem-error');
    if (el) el.style.display = 'none';
  }

  function setButtonsDisabled(disabled) {
    document.querySelectorAll('.loyalty-redeem-btn, #loyalty-redeem-custom-btn').forEach(function (btn) {
      btn.disabled = disabled;
    });
  }

  function updateButtonStates(newPoints) {
    document.querySelectorAll('.loyalty-redeem-btn').forEach(function (btn) {
      var required = parseInt(btn.getAttribute('data-points'));
      btn.disabled = newPoints < required;
    });
    var cb = document.getElementById('loyalty-redeem-custom-btn');
    var minRedeem = window.__loyaltyMinRedeem || FALLBACK_MIN_REDEEM;
    if (cb) cb.disabled = newPoints < minRedeem;
    var ci = document.getElementById('loyalty-custom-points');
    if (ci) ci.max = newPoints;
  }

  // =============================================
  // REWARD PRODUCT REDEEM
  // =============================================

  var redeemBtns = document.querySelectorAll('.loyalty-redeem-product-btn');
  var redeemWidget = document.getElementById('loyalty-redeem-widget');
  var redeemCustomerId = redeemWidget ? redeemWidget.getAttribute('data-customer-id') : null;

  redeemBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var productGid = this.getAttribute('data-product-gid');
      var pointsNeeded = parseInt(this.getAttribute('data-points'));
      var productTitle = this.getAttribute('data-title');

      // BUGFIX (B2): deze hele flow was 100% hardgecodeerd Nederlands, zonder enig
      // vertaalmechanisme — een Canadese klant kreeg de complete inwissel-flow voor
      // een beloningsproduct in het Nederlands. Nu via rt()/ct() -> FALLBACK_CONTENT
      // (sectie 'redeem'), exact hetzelfde mechanisme als het bestaande
      // punten-inwissel-succes-/foutpad hierboven.
      if (!redeemCustomerId) { showError(rt('login_required')); return; }
      if (!confirm(rt('confirm_product').replace('{points}', pointsNeeded).replace('{title}', productTitle))) return;

      btn.disabled = true;
      btn.textContent = rt('processing');

      fetch(PROXY_BASE + '/redeem-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ product_id: productGid })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.error) {
            showError(translateApiError(data));
            btn.disabled = false;
            btn.textContent = rt('redeem_button');
            return;
          }

          // Update hero punten direct
          var heroEl = document.querySelector('.loyalty-hero__points-value');
          if (heroEl) heroEl.textContent = data.new_balance;

          btn.textContent = rt('adding_to_cart');

          if (!data.variant_id) {
            // Fallback: oude flow als variant_id ontbreekt
            var card = btn.closest('.loyalty-reward-card__info');
            if (card) {
              card.insertAdjacentHTML('beforeend',
                '<div class="loyalty-reward-card__redeemed">' +
                '<div>' + escapeHtml(rt('code_prefix')) + '<strong>' + escapeHtml(data.discount_code) + '</strong></div>' +
                '<a href="' + escapeAttr(data.product_url) + '" class="loyalty-btn loyalty-btn--primary" style="margin-top:8px;font-size:12px;padding:8px 16px">' + escapeHtml(rt('add_to_cart_button')) + '</a>' +
                '</div>'
              );
            }
            btn.textContent = rt('redeemed');
            btn.style.background = '#202449';
            return;
          }

          // Voeg variant toe aan cart via Shopify Cart AJAX API
          var routes = (window.Shopify && window.Shopify.routes) || {};
          var localeRoot = (routes.root || '/').replace(/\/$/, ''); // '' voor default, '/nl' voor NL, '/de-de' voor DE
          var cartAddUrl = routes.cart_add_url || (localeRoot + '/cart/add.js');
          var cartUrl = localeRoot + '/cart';
          // Shopify's /discount/CODE?redirect=... wil het redirect-pad RAW (niet URL-encoded).
          // Alleen de discount-code zelf encoden (kan speciale chars bevatten).
          var discountUrl = localeRoot + '/discount/' + encodeURIComponent(data.discount_code) + '?redirect=' + cartUrl;

          fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(data.variant_id, 10), quantity: 1 }] })
          })
            .then(function (r) {
              if (!r.ok) throw new Error('cart-add-failed');
              return r.json();
            })
            .then(function () {
              // Pas kortingscode toe + ga naar cart (markt/taal-prefix bewaard)
              window.location.href = discountUrl;
            })
            .catch(function () {
              // Cart-add gefaald — toon code + handmatige link als fallback
              var card = btn.closest('.loyalty-reward-card__info');
              if (card) {
                card.insertAdjacentHTML('beforeend',
                  '<div class="loyalty-reward-card__redeemed">' +
                  '<div>' + escapeHtml(rt('your_code_prefix')) + '<strong>' + escapeHtml(data.discount_code) + '</strong></div>' +
                  '<a href="' + escapeAttr(data.product_url) + '" class="loyalty-btn loyalty-btn--primary" style="margin-top:8px;font-size:12px;padding:8px 16px">' + escapeHtml(rt('add_to_cart_manual_button')) + '</a>' +
                  '</div>'
                );
              }
              btn.textContent = rt('redeemed');
              btn.style.background = '#202449';
            });
        })
        .catch(function (err) {
          showError(err.message);
          btn.disabled = false;
          btn.textContent = rt('redeem_button');
        });
    });
  });

  // =============================================
  // REFERRAL STATISTIEKEN
  // =============================================

  var refShare = document.getElementById('loyalty-referral-share');
  if (refShare) {
    var statsEl = document.getElementById('loyalty-referral-stats');

    fetch(PROXY_BASE + '/referral-stats')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (statsEl && data.successfulReferrals > 0) {
          // B2: " punten verdiend" was hardgecodeerd Nederlands — via
          // ct('referral', 'points_earned_suffix') -> FALLBACK_CONTENT.
          statsEl.innerHTML = '<div class="loyalty-referral__stats-row">' +
            '<span><strong>' + Number(data.successfulReferrals) + '</strong> referrals</span>' +
            '<span><strong>+' + Number(data.totalPointsEarned) + '</strong> ' + escapeHtml(ct('referral', 'points_earned_suffix')) + '</span>' +
            '</div>';
        }
      })
      .catch(function () {});
  }

  // =============================================
  // PROFIEL FORMULIER — dynamisch uit API
  // =============================================

  var profileForm = document.getElementById('loyalty-profile-form');
  if (profileForm) {
    var pLang = profileForm.getAttribute('data-lang') || PAGE_LANG;
    var pt = function (key) { return escapeHtml(profileForm.getAttribute('data-t-' + key) || key); };

    fetch(PROXY_BASE + '/profile')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.fields || !data.fields.length) {
          profileForm.innerHTML = '';
          return;
        }

        var totalAvailable = data.totalAvailable || 0;
        var totalEarned = data.totalEarned || 0;
        var pct = totalAvailable > 0 ? Math.round((totalEarned / totalAvailable) * 100) : 0;

        var html = '<div class="loyalty-profile__progress">' +
          '<div class="loyalty-profile__progress-bar"><div class="loyalty-profile__progress-fill" style="width:' + pct + '%"></div></div>' +
          '<span class="loyalty-profile__progress-text">' + pt('progress') + ': ' + totalEarned + '/' + totalAvailable + ' ' + pt('earn') + '</span>' +
          '</div><div class="loyalty-profile__fields">';

        data.fields.forEach(function (field) {
          var label = (field.labels && field.labels[pLang]) || (field.labels && field.labels.nl) || field.field_key;
          var completed = field.points_awarded;
          var pointsText = completed
            ? '<span class="loyalty-profile__pts loyalty-profile__pts--done">&#10003; +' + field.points_reward + ' ' + pt('earned') + '</span>'
            : (field.points_reward > 0 ? '<span class="loyalty-profile__pts">+' + field.points_reward + ' ' + pt('earn') + '</span>' : '');

          html += '<div class="loyalty-profile__field' + (completed ? ' loyalty-profile__field--completed' : '') + '">';
          html += '<label class="loyalty-profile__label">' + escapeHtml(label) + ' ' + pointsText + '</label>';

          var val = field.value || '';

          if (field.field_type === 'text') {
            html += '<input type="text" class="loyalty-profile__input" data-key="' + field.field_key + '" value="' + escapeAttr(val) + '">';
          } else if (field.field_type === 'date') {
            html += '<input type="date" class="loyalty-profile__input" data-key="' + field.field_key + '" value="' + escapeAttr(val) + '">';
          } else if (field.field_type === 'number') {
            html += '<input type="number" class="loyalty-profile__input" data-key="' + field.field_key + '" value="' + escapeAttr(val) + '">';
          } else if (field.field_type === 'checkbox') {
            html += '<label class="loyalty-profile__checkbox"><input type="checkbox" data-key="' + field.field_key + '" ' + (val === 'true' ? 'checked' : '') + '> ' + escapeHtml(label) + '</label>';
          } else if (field.field_type === 'select') {
            var selectAllowTextValues = (field.options || []).filter(function (o) { return o.allow_text; }).map(function (o) { return o.value; });
            html += '<select class="loyalty-profile__input" data-key="' + field.field_key + '">';
            html += '<option value="">' + pt('select') + '</option>';
            (field.options || []).forEach(function (opt) {
              var optLabel = (opt.labels && (opt.labels[pLang] || opt.labels.nl)) || opt.value;
              html += '<option value="' + escapeAttr(opt.value) + '"' + (val === opt.value ? ' selected' : '') + '>' + escapeHtml(optLabel) + '</option>';
            });
            html += '</select>';
            if (selectAllowTextValues.length > 0) {
              var selectTextExtraVisible = selectAllowTextValues.indexOf(val) !== -1;
              var selectTextExtraVal = escapeAttr(field.text_extra || '');
              html += '<div class="loyalty-profile__text-extra" data-field-key="' + field.field_key + '" style="' + (selectTextExtraVisible ? '' : 'display:none;') + 'margin-top:8px">' +
                '<input type="text" class="loyalty-profile__input" maxlength="500" data-text-extra-input="' + field.field_key + '" placeholder="' + escapeAttr(ct('profile', 'other_placeholder')) + '" value="' + selectTextExtraVal + '">' +
                '</div>';
            }
          } else if (field.field_type === 'multiselect') {
            var selectedArr = [];
            try { selectedArr = JSON.parse(val); } catch (e) {}
            var multiAllowTextValues = (field.options || []).filter(function (o) { return o.allow_text; }).map(function (o) { return o.value; });
            html += '<div class="loyalty-profile__multiselect" data-key="' + field.field_key + '">';
            (field.options || []).forEach(function (opt) {
              var optLabel = (opt.labels && (opt.labels[pLang] || opt.labels.nl)) || opt.value;
              var isChecked = selectedArr.indexOf(opt.value) !== -1;
              html += '<label class="loyalty-profile__multi-option"><input type="checkbox" value="' + escapeAttr(opt.value) + '"' + (isChecked ? ' checked' : '') + '> ' + escapeHtml(optLabel) + '</label>';
            });
            html += '</div>';
            if (multiAllowTextValues.length > 0) {
              var multiAnyChecked = selectedArr.some(function (v) { return multiAllowTextValues.indexOf(v) !== -1; });
              var multiTextExtraVal = escapeAttr(field.text_extra || '');
              html += '<div class="loyalty-profile__text-extra" data-field-key="' + field.field_key + '" style="' + (multiAnyChecked ? '' : 'display:none;') + 'margin-top:8px">' +
                '<input type="text" class="loyalty-profile__input" maxlength="500" data-text-extra-input="' + field.field_key + '" placeholder="' + escapeAttr(ct('profile', 'other_placeholder')) + '" value="' + multiTextExtraVal + '">' +
                '</div>';
            }
          }

          html += '</div>';
        });

        html += '</div>';
        html += '<button class="loyalty-btn loyalty-btn--primary" id="loyalty-profile-save">' + pt('save') + '</button>';
        html += '<div id="loyalty-profile-status" class="loyalty-profile__status" style="display:none"></div>';

        profileForm.innerHTML = html;

        // Show/hide "Anders, namelijk..." inputs based on current selection
        try {
          data.fields.forEach(function (field) {
            if (field.field_type === 'select') {
              var allowTextValues = (field.options || []).filter(function (o) { return o.allow_text; }).map(function (o) { return o.value; });
              if (!allowTextValues.length) return;
              var selectEl = profileForm.querySelector('select[data-key="' + field.field_key + '"]');
              var wrapperEl = profileForm.querySelector('.loyalty-profile__text-extra[data-field-key="' + field.field_key + '"]');
              if (!selectEl || !wrapperEl) return;
              selectEl.addEventListener('change', function () {
                var selected = selectEl.value;
                if (allowTextValues.indexOf(selected) !== -1) {
                  wrapperEl.style.display = '';
                } else {
                  wrapperEl.style.display = 'none';
                  var inp = wrapperEl.querySelector('[data-text-extra-input]');
                  if (inp) inp.value = '';
                }
              });
            } else if (field.field_type === 'multiselect') {
              var allowTextValues = (field.options || []).filter(function (o) { return o.allow_text; }).map(function (o) { return o.value; });
              if (!allowTextValues.length) return;
              var multiDiv = profileForm.querySelector('.loyalty-profile__multiselect[data-key="' + field.field_key + '"]');
              var wrapperEl = profileForm.querySelector('.loyalty-profile__text-extra[data-field-key="' + field.field_key + '"]');
              if (!multiDiv || !wrapperEl) return;
              multiDiv.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
                cb.addEventListener('change', function () {
                  var anyAllowChecked = false;
                  multiDiv.querySelectorAll('input[type="checkbox"]:checked').forEach(function (checked) {
                    if (allowTextValues.indexOf(checked.value) !== -1) anyAllowChecked = true;
                  });
                  if (anyAllowChecked) {
                    wrapperEl.style.display = '';
                  } else {
                    wrapperEl.style.display = 'none';
                    var inp = wrapperEl.querySelector('[data-text-extra-input]');
                    if (inp) inp.value = '';
                  }
                });
              });
            }
          });
        } catch (e) {}

        document.getElementById('loyalty-profile-save').addEventListener('click', function () {
          var saveBtn = this;
          saveBtn.disabled = true;
          saveBtn.textContent = '...';

          var values = {};
          profileForm.querySelectorAll('[data-key]').forEach(function (el) {
            var key = el.getAttribute('data-key');
            if (el.type === 'checkbox' && !el.closest('.loyalty-profile__multiselect')) {
              values[key] = el.checked ? 'true' : 'false';
            } else if (el.classList.contains('loyalty-profile__multiselect')) {
              var checked = [];
              el.querySelectorAll('input[type="checkbox"]:checked').forEach(function (cb) { checked.push(cb.value); });
              values[key] = checked;
            } else {
              if (el.value) values[key] = el.value;
            }
          });

          var text_extras = {};
          try {
            profileForm.querySelectorAll('[data-text-extra-input]').forEach(function (inp) {
              var wrapper = inp.closest('[data-field-key]');
              if (wrapper && wrapper.style.display !== 'none') {
                text_extras[inp.dataset.textExtraInput] = inp.value.trim();
              }
            });
          } catch (e) {}

          fetch(PROXY_BASE + '/profile', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ values: values, text_extras: text_extras })
          })
            .then(function (res) { return res.json(); })
            .then(function (result) {
              saveBtn.disabled = false;
              saveBtn.textContent = pt('save');
              var statusEl = document.getElementById('loyalty-profile-status');
              if (result.error) {
                statusEl.textContent = translateApiError(result);
                statusEl.className = 'loyalty-profile__status loyalty-profile__status--error';
                statusEl.style.display = 'block';
                return;
              }

              var msg = pt('saved');
              if (result.pointsAwarded > 0) {
                msg += ' +' + result.pointsAwarded + ' ' + pt('earn') + '!';
                var heroEl = document.querySelector('.loyalty-hero__points-value');
                if (heroEl) heroEl.textContent = result.newBalance;
              }
              statusEl.textContent = msg;
              statusEl.className = 'loyalty-profile__status loyalty-profile__status--success';
              statusEl.style.display = 'block';

              setTimeout(function () { location.reload(); }, 1500);
            })
            .catch(function (err) {
              saveBtn.disabled = false;
              saveBtn.textContent = pt('save');
              var statusEl = document.getElementById('loyalty-profile-status');
              statusEl.textContent = err.message;
              statusEl.className = 'loyalty-profile__status loyalty-profile__status--error';
              statusEl.style.display = 'block';
            });
        });
      })
      .catch(function () { profileForm.innerHTML = ''; });
  }

  // =============================================
  // TRANSACTIEHISTORIE
  // Wacht op config zodat data-t-* attributes al zijn ingevuld door applyContent()
  // vóór de tabel-headers worden gelezen.
  // =============================================

  function formatDesc(text) {
    if (!text) return '';
    var safe = escapeHtml(text);
    var colonIdx = safe.indexOf(':');
    if (colonIdx === -1) return safe;
    var title = safe.substring(0, colonIdx + 1);
    var body = safe.substring(colonIdx + 1).trim();
    if (!body) return title;
    return '<strong>' + title + '</strong><br>' + body;
  }

  window._loyaltyConfigReady.then(function () {
    var historyEl = document.getElementById('loyalty-history');
    if (historyEl) {
      var htRaw = function (key) { return historyEl.getAttribute('data-t-' + key) || key; };
      // ht() = tekstinhoud (th's, lege-staat-tekst, type-labels) — escapeHtml volstaat.
      var ht = function (key) { return escapeHtml(htRaw(key)); };
      // htAttr() = attribuutwaarden (data-label="...") — SECURITY (F9): deze
      // data-t-* waarden komen uit het publieke, admin-beheerde loyalty-page-config
      // en moeten quote-safe geescaped worden voor ze in een attribuut belanden.
      var htAttr = function (key) { return escapeAttr(htRaw(key)); };
      var typeLabels = { earn: ht('earn'), redeem: ht('redeem'), adjust: ht('adjust'), expire: ht('expire') };

      fetch(PROXY_BASE + '/history')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data.transactions || !data.transactions.length) {
            historyEl.innerHTML = '<p class="loyalty-history__empty">' + ht('empty') + '</p>';
            return;
          }

          var html = '<div class="loyalty-history__table"><table>' +
            '<thead><tr><th>' + ht('date') + '</th><th>' + ht('desc') + '</th>' +
            '<th class="loyalty-history__right">' + ht('points') + '</th>' +
            '<th class="loyalty-history__right">' + ht('balance') + '</th></tr></thead><tbody>';

          data.transactions.forEach(function (tx) {
            var sign = tx.points >= 0 ? '+' : '';
            var cls = tx.points >= 0 ? 'loyalty-history__positive' : 'loyalty-history__negative';
            // Re-read typeLabels to pick up any config-applied updates
            var tl = { earn: ht('earn'), redeem: ht('redeem'), adjust: ht('adjust'), expire: ht('expire') };
            var typeLabel = tl[tx.type] || tx.type;
            var desc = tx.description || typeLabel;
            var date = new Date(tx.created_at).toLocaleDateString();

            var dateLabel = htAttr('date');
            var descLabel = htAttr('desc');
            var pointsLabel = htAttr('points');
            var balanceLabel = htAttr('balance');
            html += '<tr>' +
              '<td data-label="' + dateLabel + '"><span>' + date + '</span></td>' +
              '<td data-label="' + descLabel + '"><span>' + formatDesc(desc) + '</span></td>' +
              '<td data-label="' + pointsLabel + '" class="loyalty-history__right ' + cls + '"><span>' + sign + tx.points + '</span></td>' +
              '<td data-label="' + balanceLabel + '" class="loyalty-history__right"><span>' + tx.balance_after + '</span></td>' +
              '</tr>';
          });

          html += '</tbody></table></div>';
          historyEl.innerHTML = html;
        })
        .catch(function () { historyEl.innerHTML = ''; });
    }
  });

  // =============================================
  // MIJN KORTINGSCODES — fetch + render
  // Wacht op config zodat data-t-* attributes al zijn ingevuld door applyContent()
  // vóór de kortingscodes-lijst wordt gebouwd.
  // =============================================
  window._loyaltyConfigReady.then(function () {
    var mrEl = document.getElementById('loyalty-my-rewards');
    if (mrEl) {
      var mrt = function (key) { return escapeHtml(mrEl.getAttribute('data-t-' + key) || key); };

      fetch(PROXY_BASE + '/rewards')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var rewards = data && data.rewards || [];
          if (!rewards.length) {
            mrEl.innerHTML = '<p class="loyalty-my-rewards__empty">' + mrt('empty') + '</p>';
            return;
          }

          var routes = (window.Shopify && window.Shopify.routes) || {};
          var localeRoot = (routes.root || '/').replace(/\/$/, '');

          // Deel A (a): GET /apps/loyalty/rewards levert nu een top-level `currency`
          // (settlement-valuta van de tenant, zie server/routes/storefront.js). Zelfde
          // defensieve keten als overal in dit bestand: data.currency -> _configCurrency
          // -> 'EUR' (via formatConverted()/resolveCurrency()'s eigen fallback).
          var rewardsCurrency = (data && data.currency) || _configCurrency;

          var statusBadge = function (s) {
            var key = s === 'used' ? 'status_used' : s === 'expired' ? 'status_expired' : 'status_active';
            var cls = 'loyalty-my-rewards__badge loyalty-my-rewards__badge--' + s;
            return '<span class="' + cls + '">' + mrt(key) + '</span>';
          };

          // BUGFIX (Deel A-a): voorheen hardcoded '&euro;' + Number(...).toFixed(2)
          // .replace('.', ',') — altijd een euroteken MET Nederlandse komma-decimaal,
          // ook voor een CAD-kortingscode op happyfarmerna.com of een Engelstalige
          // klant (die een punt-decimaal verwacht). formatConverted() hergebruikt
          // formatMoney() (ongewijzigd, zie toelichting daar) voor zowel de juiste
          // valuta/symbool-positie als de juiste locale-afhankelijke decimaalnotatie,
          // én rekent — net als de rest van Deel A — om naar de actieve presentment-
          // valuta als de bezoeker de currency switcher gebruikte.
          var formatValue = function (r) {
            if (r.discount_type === 'fixed_amount') {
              return escapeHtml(formatConverted(r.discount_value, rewardsCurrency, resolveLocale(),
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            }
            if (r.discount_type === 'percentage') return Number(r.discount_value) + '%';
            return escapeHtml(String(r.discount_value));
          };

          var formatDate = function (iso) {
            if (!iso) return '';
            try { return new Date(iso).toLocaleDateString(); } catch (_) { return escapeHtml(iso); }
          };

          var html = '<ul class="loyalty-my-rewards__list">';
          rewards.forEach(function (r) {
            // SECURITY (F11): twee varianten — `code` is escapeHtml'd voor TEKSTINHOUD
            // (weergave in .loyalty-my-rewards__code), `codeAttr` is escapeAttr'd voor
            // gebruik in het data-code="..." attribuut hieronder.
            var code = escapeHtml(r.discount_code || '');
            var codeAttr = escapeAttr(r.discount_code || '');
            var value = formatValue(r);
            var isActive = r.live_status === 'active';
            var dateLine = isActive
              ? (r.expires_at ? mrt('expires_label') + ' ' + formatDate(r.expires_at) : '')
              : r.live_status === 'used'
                ? (r.used_at ? mrt('used_label') + ' ' + formatDate(r.used_at) : '')
                : (r.expires_at ? formatDate(r.expires_at) : '');

            var productLine = '';
            if (r.reward_type === 'product' && r.product_handle) {
              var pTitle = r.product_title || r.product_handle;
              var pHref = localeRoot + '/products/' + encodeURIComponent(r.product_handle);
              productLine = '<div class="loyalty-my-rewards__product">' +
                '🔒 ' + mrt('product_only_label') + ' ' +
                '<a href="' + escapeAttr(pHref) + '">' + escapeHtml(pTitle) + '</a>' +
                '</div>';
            } else if (r.reward_type === 'product') {
              // Fallback voor oude rewards zonder product_handle (vóór DB-migratie)
              productLine = '<div class="loyalty-my-rewards__product">' +
                '🔒 ' + mrt('product_only_generic') +
                '</div>';
            }

            html += '<li class="loyalty-my-rewards__item loyalty-my-rewards__item--' + r.live_status + '">' +
              '<div class="loyalty-my-rewards__row">' +
                '<div class="loyalty-my-rewards__main">' +
                  '<div class="loyalty-my-rewards__code">' + code + '</div>' +
                  '<div class="loyalty-my-rewards__value">' + value + ' &mdash; ' + Number(r.points_cost) + ' ' + mrt('points_label') + '</div>' +
                  productLine +
                  '<div class="loyalty-my-rewards__meta">' + statusBadge(r.live_status) + (dateLine ? ' &middot; ' + escapeHtml(dateLine) : '') + '</div>' +
                '</div>' +
                (isActive ? (
                  '<div class="loyalty-my-rewards__actions">' +
                    '<button type="button" class="loyalty-btn loyalty-btn--outline loyalty-my-rewards__copy" data-code="' + codeAttr + '">' + mrt('copy_button') + '</button>' +
                    '<a class="loyalty-btn loyalty-btn--primary" href="' + localeRoot + '/discount/' + encodeURIComponent(r.discount_code) + '?redirect=' + localeRoot + '/cart">' + mrt('apply_button') + '</a>' +
                  '</div>'
                ) : '') +
              '</div>' +
            '</li>';
          });
          html += '</ul>';
          mrEl.innerHTML = html;

          // Wire copy buttons
          var copiedLabel = mrEl.getAttribute('data-t-copied') || 'Gekopieerd!';
          mrEl.querySelectorAll('.loyalty-my-rewards__copy').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var c = this.getAttribute('data-code');
              if (!c) return;
              var orig = this.textContent;
              var self = this;
              var done = function () {
                self.textContent = copiedLabel;
                setTimeout(function () { self.textContent = orig; }, 1500);
              };
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(c).then(done).catch(function () {
                  try { var ta = document.createElement('textarea'); ta.value = c; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done(); } catch (_) {}
                });
              } else {
                try { var ta = document.createElement('textarea'); ta.value = c; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done(); } catch (_) {}
              }
            });
          });
        })
        .catch(function () { mrEl.innerHTML = ''; });
    }
  });

  // =============================================
  // TIER OVERZICHT — dynamisch uit API
  // =============================================

  var tiersGrid = document.getElementById('loyalty-tiers-grid');
  if (tiersGrid) {
    var currentTier = tiersGrid.getAttribute('data-current-tier') || '';
    var t_ = function (key) { return escapeHtml(tiersGrid.getAttribute('data-t-' + key) || key); };

    fetch(withShopParam(API_URL + '/api/public/tiers'))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data.tiers || !data.tiers.length) return;
        // Nieuw servercontract: GET /api/public/tiers -> { tiers, currency, locale }.
        // Deze fetch is onafhankelijk van de loyalty-page-config-fetch hierboven
        // (andere endpoint, kan eerder/later/nooit resolven) — daarom een eigen
        // currency/locale-resolutie i.p.v. blind op de gedeelde _configCurrency/
        // _configLang module-state te vertrouwen. Val terug op die gedeelde state
        // (mogelijk al gevuld door de config-fetch) en pas daarna op de vaste
        // EUR/nl-defaults, voor het geval een oudere serverversie deze twee nieuwe
        // velden nog niet meestuurt.
        var tiersCurrency = data.currency || _configCurrency;
        // tiersLocale is de "geen conversie"-locale (tenant-standaardtaal via data.locale,
        // exact het bestaande gedrag) — formatConverted() gebruikt 'm alleen zolang er niet
        // daadwerkelijk is omgerekend, en schakelt zelf over op resolveLocale() (de
        // paginataal) zodra dat wel het geval is. Zie de toelichting bij formatConverted()
        // voor de volledige regel + waarom (BUGFIX live-controle ronde 2: een Zweeds
        // omgerekend bedrag met Nederlandse conventies gaf "SEK 10.990" i.p.v. "10 990 kr").
        var tiersLocale = normalizeLocale(data.locale) || resolveLocale();
        tiersGrid.innerHTML = data.tiers.map(function (tier) {
          var isActive = currentTier === tier.tier_name;
          var tierLabel = t_(tier.tier_name);
          // SECURITY (F12): points_multiplier en discount_percent kwamen hiervoor volledig
          // ongeescaped in de innerHTML terecht (geen quotes nodig — een volledige tag met
          // bv. een onerror-handler volstond), terwijl min_spend hieronder al wél met
          // Math.round() werd gecoerced. Number() dwingt af dat een niet-numerieke waarde
          // hooguit als de tekst "NaN" landt, nooit als HTML/JS.
          var pointsMultiplier = Number(tier.points_multiplier);
          var discountPercent = Number(tier.discount_percent);
          // "€1" -> "<symbool>1": vaste valuta-eenheid van de multiplier-omschrijving (1
          // eenheid BASISVALUTA), geen bedrag uit tier zelf. Deel A: nu via
          // formatConverted() i.p.v. formatMoney() — als de bezoeker via de currency
          // switcher een andere presentment-valuta koos, moet ook deze "1 eenheid"
          // meebewegen (bv. "1x punten per kr11" i.p.v. "1x punten per €1" op een
          // SEK-geswitchte HF-EU-bezoeker).
          //
          // BUGFIX (live-controle ronde 2) — ADAPTIEVE DECIMALEN, UITSLUITEND HIER: bij een
          // vaste maximumFractionDigits:0 rondt een koers < 1 dit bedrag FEITELIJK ONJUIST
          // af — 1 CAD * 0,73165... USD werd getoond als "$1" (37% naast de werkelijke
          // verdienratio; bij een koers < 0,5 zou het zelfs "$0" worden). Bij een koers >= 1
          // is 0 decimalen verwaarloosbare afronding ("11 kr" bij 10,99 — geen probleem).
          // Bepaal het omgerekende bedrag daarom VOORAF via resolveCurrency() (dezelfde
          // resolutie die formatConverted() intern toepast) en kies 0 decimalen bij >= 1
          // eenheid, 2 decimalen bij < 1 eenheid: "$0.73", "11 kr", en op NL/CAD ONGEWIJZIGD
          // "€1"/"CA$1". Raakt UITSLUITEND deze eenheidsprijs — de tier-drempel (spendText
          // hieronder) blijft altijd op 0 decimalen, ongeacht de koers.
          var unitRate = resolveCurrency(tiersCurrency).rate;
          var unitOpts = (unitRate >= 1) ? { maximumFractionDigits: 0 } : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
          var unitAmountText = formatConverted(1, tiersCurrency, tiersLocale, unitOpts);
          var benefits = '<li>' + pointsMultiplier + 'x ' + t_('points') + ' ' + escapeHtml(unitAmountText) + '</li>' +
            (discountPercent ? '<li>' + discountPercent + '% ' + t_('discount') + '</li>' : '') +
            (tier.free_shipping ? '<li>' + t_('shipping') + '</li>' : '');
          // maximumFractionDigits:0 behoudt het huidige gedrag (géén decimalen op de
          // spend-drempel — "Vanaf €0", niet "Vanaf €0,00"). formatConverted rekent om
          // naar de gekozen presentment-valuta (Deel A) en formatMoney rondt zelf af
          // (via Intl) — losse Math.round() is niet meer nodig. Op de basismarkt van
          // elke winkel (rate 1.0) is de uitkomst identiek aan vóór deze fix.
          var spendText = formatConverted(tier.min_spend, tiersCurrency, tiersLocale, { maximumFractionDigits: 0 });
          return '<div class="loyalty-tier-overview' + (isActive ? ' loyalty-tier-overview--active' : '') + '">' +
            '<div class="loyalty-tier-overview__emoji">' + escapeHtml(tier.badge_emoji) + '</div>' +
            '<h3 class="loyalty-tier-overview__name">' + escapeHtml(tierLabel) + '</h3>' +
            '<div class="loyalty-tier-overview__spend">' + t_('from') + ' ' + escapeHtml(spendText) + '</div>' +
            '<ul class="loyalty-tier-overview__benefits">' + benefits + '</ul>' +
            (isActive ? '<div class="loyalty-tier-overview__badge">' + t_('current') + '</div>' : '') +
            '</div>';
        }).join('');
      })
      .catch(function () {});
  }

})();
